$(document).ready(function () {
	// Global Variables

	const progressListItems = $("#progressbar li");
	let currentStep = 0;
	let otp_steps = 0;
	let api_token = "";
	let pincode_error_flag = false;
	let jwt_token = "";
	//let reg_error_flag = false;
	//let reg_error_msg = ""; 
	
	/*------------- Handle vehicle selection in multiple vehicle view------------*/

	$(document).on('change', '.vehicle-select-radio', function() {
		let selectedVehicleId = $(this).closest('.item').find('.vehicleID').text();
		$("#vehicle_id").val(selectedVehicleId);
		$(".next-step").prop("disabled", false);
	});

	const base_url = window.TVSMOTOR_CONFIG?.base_url || '';

	// console.log("Base URL from settings:", base_url);

	//const base_url = "http://localhost:8083/book_a_service";   
	// const base_url = "https://uat-ecom-api.tvsmotor.net/book_a_service";
	// const base_url = "https://bookaservice.1hour.in/book_a_service";

	let mobileNoError = false;
	var token = "";
	let now = new Date();
	let selectedBikeImage = "";
	let selectedDealerName = "";
	let selectedDealerAddress = "";  
	let chanel="";
	//let selectedDealerId = ""; 

	now.setTime(now.getTime() + 50 * 60 * 1000);
	let expires = "expires=" + now.toUTCString();

	function isCookieSet(cookieName) {
		return document.cookie.split(";").some((cookie) => {
			return cookie.trim().startsWith(cookieName + "=");
		}); 
	}

	// Initial render of disabled-catcher overlay
	try { updateDisabledCatcher(); } catch (e) {}

	function deleteCookie(name) {
		document.cookie =
			name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	} 

	$("#mobile_no").on("input", function () {
		let value = $(this).val();
		if (!/^\d$/.test(value) || value === "0") {
			$(this).val("");
		}
		if (value.length > 1) {
			$(this).val(value.slice(0, 10));
		}
	});  

	const mobile = '9676579888';
	const frameNo = 'MD626AM17T1F10825';
	// const mobile = '';
	// const frameNo = '';
	var url = ''; 
	function createTestToken(mobile, frameNo) {
		$.ajax({
			url: base_url + `/encrypt`,
			method: 'GET',
			data: { mobile, frameNo },
			dataType: 'json',
			timeout: 5000,
			success: function(res) {
				// console.log('AJAX success', res);
				if (res.status) {
					// Build URL with token and frameNo
					var token = encodeURIComponent(res.token || '');
					var frame = encodeURIComponent(frameNo || '');
					url = `https://service.tvsmotor.com?token=${token}&frameNo=${frame}&channel=TVSCONNECT`; 
					connectHomeUrl = url;
					 //console.log('Generated URL:', url);
					// console.log("connectHomeUrl ", connectHomeUrl);
				} else {
					console.error('API returned error:', res.message);
				}
			},
			error: function(xhr, textStatus, errorThrown) {
				console.error('AJAX error:', textStatus, errorThrown);
				if (xhr) {
					console.error('Status:', xhr.status);
					try { console.error('Response:', xhr.responseText); } catch(e) {}
				}
			}
		});
	}
	
	//  Create URL for testing

	createTestToken(mobile, frameNo);
	function getURLParameter(name) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name);
	}
	
	const mobileToken = getURLParameter("token");
	const urlFrameNo = getURLParameter("frameNo");
	let urlChanel = getURLParameter("channel");
	let connectHomeUrl = url;
	// console.log("URL chanel ", urlChanel);
	// console.log("connectHomeUrl ", connectHomeUrl); // Moved to success callback
	// Keep track of last token used
	window._mobileFromTokenPromise = null;
	window._lastTokenUsed = null;

	function hydrateMobileFromToken() {
		
		// No token → nothing to do
		if (!mobileToken) {
			return Promise.resolve(null);
		}

		// If same token already being processed, reuse promise
		if (
			window._mobileFromTokenPromise &&
			window._lastTokenUsed === mobileToken
		) {
			return window._mobileFromTokenPromise;
		}

		// Token changed → reset previous promise
		window._lastTokenUsed = mobileToken;
		window._mobileFromTokenPromise = new Promise((resolve) => {

			$.ajax({
				url: base_url + `/getmobilenumber`,
				method: "GET",
				data: { token: mobileToken },

				success: function (response) {
					try {
						const mob = response?.mobile
							? String(response.mobile).trim()
							: "";

						// Validate 10-digit Indian mobile
						if (/^\d{10}$/.test(mob)) {

							// Always overwrite cookie in deep link case
							setCookie("mobileNo", mob);
							console.log('Mobile_number_om', mob);
							// Update UI
							$("#mobile_no").val(mob);
							$("#mobile").val(mob);
							$("#grand-total-estimated-value-sticky")
								.html("+91 " + mob);

							resolve(mob);
							return;
						}

					} catch (e) {
						console.error("Mobile parse error:", e);
					}

					// Invalid mobile → allow retry
					window._mobileFromTokenPromise = null;
					resolve(null);
				},

				error: function (err) {
					console.error("Token API failed:", err);

					// Reset promise so future retry possible
					window._mobileFromTokenPromise = null;
					resolve(null);
				}
			});
		});

		return window._mobileFromTokenPromise;
	}



	// Keep existing behavior: attempt to hydrate ASAP (non-blocking)
	hydrateMobileFromToken();
	// Function to check URL and bypass login if mobile number and logged_in are present
	async function checkURLAndBypassLogin() {
		let mobileNumber = getCookie("mobileNo");
		if (mobileToken && urlFrameNo && urlChanel) {
			try {
				await hydrateMobileFromToken(); 
				mobileNumber = getCookie("mobileNo"); 

				// added by dj july21-2026
				await loginFromMobile();

				if (mobileNumber) {
					loginBypassed = true; 
				}
			} catch (e) {}
		}
		
		if (mobileNumber) {
			// Hide header/footer ONLY for encrypted-token deep link URLs
			if (mobileToken) {
				$("header, footer, .shopify-section-header-sticky, .shopify-section-footer, .announcement-bar-section").hide();
			}
			// Validate mobile number (should be 10 digits)
			if (/^\d{10}$/.test(mobileNumber)) {
				// Set mobile cookie
				setCookie("mobileNo", mobileNumber);
				
				// Set mobile number in UI elements
				$("#grand-total-estimated-value-sticky").html("+91 " + mobileNumber);
				$("#mobile").val(mobileNumber);
				$("#mobile_no").val(mobileNumber);

				// Check if token exists in cookies (from previous session)
				if (isCookieSet("jwt_token")) {
					token = getCookie("jwt_token");
				} else {
					// If no token, we might need to generate one or return false
					// For now, we'll try to get customer info - API might handle it
					// console.log("No token found in cookies");
				}

				// Set otp_steps to 2 to bypass OTP verification
				otp_steps = 2;
				setCookie("otpStep", otp_steps);

				// Set current step to 1 (vehicle selection step)
				currentStep = 1;
				setCookie("currentStep", currentStep);

				// Get customer and vehicle info
				// Fetch vehicle details
				await getCustomerVehicleInfoNew(urlFrameNo);

				// Show step 1 (vehicle selection)
				showStep(currentStep);
				$(".next-step").html("Continue");
				$(".next-step").prop("disabled", false);

				return true; // Indicates login was bypassed
			} else {
				console.error("Invalid mobile number format in URL");
				return false;
			}
		}
		return false; // No bypass
	}

	// Added by dj july21-2026
	async function loginFromMobile() {

		return new Promise((resolve, reject) => {

			$.ajax({

				url: base_url + "/auth/mobile",

				method: "POST",

				xhrFields: {
					withCredentials: true
				},

				contentType: "application/json",

				data: JSON.stringify({
					token: mobileToken
				}),

				success: function(response) {

					if (response.success) {
						resolve();
					} else {
						reject(response);
					}

				}, // <-- comma was missing here

				error: function(err) {

					reject(err);

				}

			});

		});
	}

	async function setDataAfterReload() {

		if (isCookieSet("mobileNo")) {
			$("#grand-total-estimated-value-sticky").html(
				"+91 " + getCookie("mobileNo")
			);
			$("#mobile").val(getCookie("mobileNo"));
			$("#mobile_no").val(getCookie("mobileNo"));
			if (isCookieSet("currentStep")) {
				currentStep = getCookie("currentStep");
			} else {
				document.cookie = "currentStep=0; path=/; " + expires + ";";
			} 

			if (isCookieSet("otpStep")) {
				otp_steps = getCookie("otpStep");
			} else {
				document.cookie = "otpStep=0; path=/; " + expires + ";";
			}  

			if (isCookieSet("jwt_token")) {
				token = getCookie("jwt_token");
			}
			if (isCookieSet("customerId")) {
				$("#customer_id").val(getCookie("customerId"));
			}    

			if (isCookieSet("vehicleId")) {
				$("#vehicle_id").val(getCookie("vehicleId"));
			}
			if (isCookieSet("dealerId")) {
				$("#new_dealer_id").val(getCookie("dealerId"));
			}

			if (isCookieSet("pincode")) {
				$("#bs-pincode_search").val(getCookie("pincode"));
				pincode_error_flag = true;
				// await getApiLAtLongAccessToken();

				$("#" + getCookie("dealerId")).click();
			}

			if (isCookieSet("vehicleName")) {
				$("#bike_name_title").text(getCookie("vehicleName"));
				$(".bd-title").text(getCookie("vehicleName"));
			}
			showStep(currentStep);
		} else {
			deleteCookie("customerId");
			deleteCookie("pincode");
			deleteCookie("jwt_token");
			deleteCookie("vehicleId");
			deleteCookie("dealerId");
			deleteCookie("mobileNo");
			deleteCookie("currentStep");
			deleteCookie("otpStep");
		}
	}

	async function setData() {
		$("#loaderr").css("display", "flex");
		// Check URL parameters first and bypass login only when token+frameNo present
		// and channel equals TVSCONNECT (case-insensitive)
		// console.log("Checking URL for login bypass...");
		let loginBypassed = false;
		if (mobileToken && urlFrameNo && urlChanel && String(urlChanel).toUpperCase() === 'TVSCONNECT') {
			loginBypassed = await checkURLAndBypassLogin();
		} else {
			try { 
				// console.log('DEBUG: Skipping bypass — need token, frameNo and channel=TVSCONNECT'); 

			} catch (e) {}
		}
		
		// Only proceed with normal cookie-based reload if login was not bypassed
		if (!loginBypassed) {
			await setDataAfterReload();
			if (currentStep > 0) {
				// console.log('current step', currentStep);
				$(".next-step").html("Continue");
				await getCustomerVehicleInfoNew();
			}
			if (currentStep >2) {
				console.log('current step', currentStep);
				$(".next-step").show();
				let today_date = $("#booking_date").val();
				setTimeout(function () {}, 500);
			}
		} else {
			// If login was bypassed, check if we need to load slot availability
			if (currentStep > 2) {
				$(".next-step").show();
				let today_date = $("#booking_date").val();
				setTimeout(function () {}, 500);
			}
		}
		
		setTimeout(function () {
			$("#loaderr").css("display", "none");
		}, 1000);
	}
	setData();

	function setCookie(name, value) {
		// If user changes mobile, clear previous user's vehicle state to avoid showing stale cached vehicles
		if (name === "mobileNo") {
			try {
				const prev = getCookie("mobileNo");
				const next = String(value || "");
				if (prev && next && String(prev) !== next) {
					deleteCookie("vehicleId");
					deleteCookie("vehicleName");
					deleteCookie("vehicleImage");
					deleteCookie("vehicleRegNo");
					deleteCookie("vehicleFrameNo");
					deleteCookie("customerId");
					deleteCookie("customerNoRegister");
					try {
						if (window.localStorage) {
							window.localStorage.removeItem("bas_last_vehicle_v1");
						}
					} catch (e) {}
				}
			} catch (e) {}
		}

		let cookieStr = `${name}=${encodeURIComponent(value)}`;
		const date = new Date();
		date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
		cookieStr += `; ${expires}; path=/`;
		document.cookie = cookieStr;
	}

	function getCookie(cookieName) {
		var name = cookieName + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var cookieArray = decodedCookie.split(";");
		for (var i = 0; i < cookieArray.length; i++) {
			var cookie = cookieArray[i];
			while (cookie.charAt(0) === " ") {
				cookie = cookie.substring(1);
			}
			if (cookie.indexOf(name) === 0) {
				return cookie.substring(name.length, cookie.length);
			}
		}
		return false;
	}

	// Persist vehicle selection across reloads (API may lag behind addNewVehicle)
	const BAS_LAST_VEHICLE_STORAGE_KEY = "bas_last_vehicle_v1";

	function _getActiveMobileNo() {
		try {
			return (
				(typeof getCookie === "function" ? getCookie("mobileNo") : "") ||
				$("#mobile_no").val?.() ||
				$("#mobile").val?.() ||
				""
			)
				.toString()
				.trim();
		} catch (e) {
			return "";
		}
	}

	function _safeJsonParse(str) {
		try {
			return JSON.parse(str);
		} catch (e) {
			return null;
		}
	}


	/*-------------- Change Title case  for Bike Name--------------*/

	function toTitleCase(str) {
		if (!str || typeof str !== "string") return "";

		return str
			.toLowerCase()
			.replace(/\b\w/g, char => char.toUpperCase());
	}	


	function _getCachedVehicle() {
		// Prefer localStorage (bigger), fallback to cookies
		try {
			const raw = window.localStorage
				? window.localStorage.getItem(BAS_LAST_VEHICLE_STORAGE_KEY)
				: null;
			const parsed = raw ? _safeJsonParse(raw) : null;
			if (parsed && parsed.vehicle_id) {
				// Prevent cross-user cache: only accept if mobile matches
				const activeMobile = _getActiveMobileNo();
				if (!parsed.mobileNo || !activeMobile || String(parsed.mobileNo) === String(activeMobile)) {
					return parsed;
				}
				return null;
			}
		} catch (e) {}

		const vehicle_id = getCookie("vehicleId");
		if (!vehicle_id) return null;
		return {
			vehicle_id: vehicle_id,
			model: getCookie("vehicleName") || "",
			image: getCookie("vehicleImage") || "",
			reg_no: getCookie("vehicleRegNo") || "",
			frame_no: getCookie("vehicleFrameNo") || "",
			customer_id: getCookie("customerId") || "",
		};
	}

	function _persistVehicleSelection(vehicle,customer) {

		    console.log("Persisting vehicle + customer:", { vehicle, customer });

		if (!vehicle) return;
		const activeMobile = _getActiveMobileNo();
		const v = {
			vehicle_id: vehicle.vehicle_id || "",
			model: vehicle.model || "",
			reg_no: vehicle.reg_no ||"",
			frame_no: vehicle.frame_no || "",
			customer_id: vehicle.customer_id || "",
			mobileNo: activeMobile || "",
		};

		// Normalize customer (NEW)
		const c = {
			customer_id: (customer && customer.id) || "",
			customer_name: (customer && customer.name) || "",
			customer_contact: (customer && customer.contact && customer.contact[0] && customer.contact[0].number) || "",
		};
		if (!v.vehicle_id) return;

		setCookie("vehicleId", v.vehicle_id);
		if (v.model) setCookie("vehicleName", v.model);
		if (v.image) setCookie("vehicleImage", v.image);
		if (v.reg_no) setCookie("vehicleRegNo", v.reg_no);
		if (v.frame_no) setCookie("vehicleFrameNo", v.frame_no);
		if (v.customer_id) setCookie("customerId", v.customer_id);

		// Store in localStorage (for persistence across mobile changes)
		try {
			if (window.localStorage) {
				const storeObj = {
					...v,
					...c,  // ← Include customer data
					timestamp: Date.now()
				};
				window.localStorage.setItem(
					BAS_LAST_VEHICLE_STORAGE_KEY,
					JSON.stringify(storeObj)
				);
			}
		} catch (e) {}
	}

	function _renderVehicleFromCacheIfAvailable(mobileNo) {

		const cached = _getCachedVehicle();
		if (!cached || !cached.vehicle_id) return false;

		const fallbackImage =
			"https://cdn.shopify.com/s/files/1/0662/5751/8685/files/vehicle.svg?v=1770207477";
		const vehicle = {
			vehicle_id: cached.vehicle_id,
			model: cached.model || "TVS Vehicle",
			image: cached.image || fallbackImage,
			reg_no: cached.reg_no || "",
			frame_no: cached.frame_no || "",
			customer_id: cached.customer_id || "",
		};
		const customerInfo = {
			customer_id: cached.customer_id || "",
			customer_name: cached.customer_name || "",
		}
		
		console.log("✅ Extracted from cache:", { vehicle, customerInfo });

		 // Set customer info from cache
		if (cached.customer_id) {
			$("#customer_id").val(cached.customer_id);
			setCookie("customerId", cached.customer_id);
		}
		if (cached.customer_name) {
			$("#customer_name").val(cached.customer_name);
			$(".customer-name").text('Hi ' + toTitleCase(cached.customer_name));
			console.log("✅ Set customer name to:", cached.customer_name);
		} else {
			console.log("⚠️ customer_name is empty in cache");
		}


		// Mirror the successful vehicle-fetch UI path
		$("#non-existing-user").hide();
		$("#no-vehicle-found").hide();
		$(".no-vehicle-found").hide();
		$("#bike-details-step-two").show();
		$(".dealer_block-outer").show();
		$(".previous_dealer_details-head").hide();
		$(".bike-detail-content-section").hide();
		$(".bd-title").show();
		$(".arro-toggle.vehicle-toggle").show();
		$(".book_tvs_service_main").hide();
		$(".common-header-block").show();

		window.allBikes = [vehicle];


		$("#bike-detail-slider").html(`
			<div class="item" id="multiple_bike_selection">
				<input type="radio" name="bike-details" class="vehicle-select-radio" checked="checked">
				<label></label>
				<div class="bike_details">
					<div class="bike-detail-left">
						<div class="image_wrapper veh_img">
							<img src="${vehicle.image}" alt="${vehicle.model}">
						</div>
						<span class="vehicleID" style="display: none;">${vehicle.vehicle_id}</span>
					</div>
					<div class="bike_name_deatils">
						<h2 class="bike_name_title">${toTitleCase(vehicle.model)}</h2>
						<div class="bk-detail">
							<div class="bike_no">
								<p>Registration Number: </p>
								<h4 class="veh_regNo">${vehicle.reg_no}</h4>
							</div>
							<div class="bike_chasis_no">
								<p>Chassis Number: </p>
								<h4 class="veh_chaNo">${vehicle.frame_no}</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		`);

		$("#vehicle_id").val(vehicle.vehicle_id);
		_persistVehicleSelection(vehicle);

		try {
			if (vehicle.frame_no) fetchPreviousDealer(vehicle.frame_no);
		} catch (e) {}

		updateVehicleSummary(vehicle, customerInfo);
		try {
			fetchAndRenderAppointmentForVehicle(mobileNo,vehicle.frame_no);
		} catch (e) {}

		return true;
	}
	function showStep(stepIndex) {
		$(".step-container .steps").each(function (index, step) {
			if (index == stepIndex) {
				$(step).show();
			} else {
				$(step).hide();
			}
		});
		if (stepIndex != 0) $("#how_it_work").hide();
		else $("#how_it_work").show();
	}

	$(document).on("click", ".next-step", async () => {
		$("#loaderr").css("display", "block");
		$(".next-step").prop("disabled", true);
		await nextStep();
		$("#loaderr").css("display", "none");
		$(".next-step").prop("disabled", false);
	});
	$(document).on("change", "#tnc", function () {
		$("#tncError").html("");
	});

	async function nextStep(res = false) {
		let response = false;
		if (currentStep < progressListItems.length - 1) {
			if (currentStep == 0) {
				if ($("#tnc").is(":checked")) {
					if (otp_steps == 0) {
						checkMobileNo();
						if (!mobileNoError) {
							response = await loginCustomer();

							if (response) {
								otp_steps = 1;
								$("#otp_popup").show();
								$("body").addClass("overflow-hidden");
							}
						} else {
							response = false;
						}
						return false;
					} else if (otp_steps == 1) {
						response = await verifyOTP();
						if (response) {
							otp_steps = 2;
							$("#otp_popup").hide();
							$("body").removeClass("overflow-hidden");
						}
					}
					$("#tncError").html("");
				} else {
					$("#tncError").html(
						"Please Select I Agree to the Terms and Condition"
					);
				}
			} else if (currentStep == 1) {
				if ($("#vehicle_id").val() != "") {
					if (!res) {
						let jobCardCheck = await checkJobCard();
						if (!jobCardCheck) {
							$("#bike-details-step-two").show();
							$(".dealer_block-outer").show();
							$(".next-step").prop("disabled", false); // Enable continue button after form fill
						} else {
							return;
						}
					} else {
						$("#bike-details-step-two").show();
						$(".dealer_block-outer").show();
						$(".dealer_block-outer").show();
						$(".next-step").prop("disabled", false); // Enable continue button after form fill
					}
				} else toastr.error("", "Please select vehicle");
			} else if (currentStep == 3) {
				$("#bike-details-step-two").hide();
				$(".dealer_block-outer").hide();
				let error = false;
				if ($("#date_form_id").val() == "") {
					error = true;
					$("#dateError").html("This field is required");
				} else $("#dateError").html("");

				if ($("#checkbox1").is(":checked")) {
					$("#job_card_checkmark_input").val(1);
					if (
						$("#howManyKm").val() == "" ||
						$("#howManyKm").val() == undefined
					) {
						error = true;
						$("#howManyKmError").html("This field is required");
					} else $("#howManyKmError").html("");

					if (
						$("#customerVoice").val() == "" ||
						$("#customerVoice").val() == undefined
					) {
						error = true;
						$("#customerVoiceError").html("This field is required");
					} else $("#customerVoiceError").html("");
				} else {
					$("#job_card_checkmark_input").val(0);
				}
				if ($("#time_form_id").val() == "") {
					error = true;
					$("#timeError").html("This field is required");
				} else $("#timeError").html("");

				if (
					!$("#checkbox1").is(":checked") &&
					!$("#checkbox2").is(":checked")
				) {
					error = true;
					$("#jobCardYesNo").html("Please select one");
				} else $("#jobCardYesNo").html("");
				if (error) return;
				response = await addJobCard();
				if (response) $(".next-step").html("Submit");
			} else if (currentStep == 2) {
				let zxc = $("#new_dealer_id").val();
				let today_date = $("#booking_date").val();
				await Promise.all([
					setVehiclesDetailStep3(),
					setDealerDeatilsStep3(),
				]);
				setDatesInCalender();
				if ($("#new_dealer_id").val() == "") {
					toastr.error("", "Please select Dealer");
					return;
				} else {
					let zxc = $("#new_dealer_id").val();
				}
			} else if (currentStep == 4) {
				if (
					$("#amc").is(":checked") ||
					$("#rsa").is(":checked") ||
					$("#vas").is(":checked")
				)
					response = await updateJobCard();
			}

			if (response || currentStep == 2 || currentStep == 4) {
				if (otp_steps == 2) {
					currentStep++;
					if (currentStep < 4) {
						setCookie("currentStep", currentStep);
						setCookie("otpStep", otp_steps);
					}
				}
				showStep(currentStep);
			}
		}
	}

	$(document).on("click", ".otp_close", function () {
		$("#otp_popup").hide();
		$("body").removeClass("overflow-hidden");
		$(".next-step").prop("disabled", false);
		location.reload();
	});

	function checkMobileNo() {
		var mobileNo = $("#mobile_no").val();
		var mobileError = document.getElementById("mobileError");
		var regex = /^\d{10}$/;
		mobileNo = mobileNo.replace(/\D/g, "");
		if (mobileNo.length > 10) {
			mobileNo = mobileNo.substring(0, 10);
		}
		$("#mobile_no").val(mobileNo);
		if (regex.test(mobileNo)) {
			mobileError.textContent = "";
			mobileNoError = false;
		} else {
			mobileNoError = true;
			mobileError.textContent = "Enter a valid Mobile Number";
		}
	}

	$(".otp-input").on("input", function () {
		let value = $(this).val();
	
		// Allow only one digit
		if (!/^\d$/.test(value)) {
			$(this).val("");
			return;
		}
	
		// Move to next input if available
		const next = this.nextElementSibling;
		if (next && next.classList.contains("otp-input")) {
			next.focus();
		}
	
		// Check if all inputs are filled
		const allFilled = $(".otp-input").toArray().every(input => input.value.trim().length === 1);
		if (allFilled) {
			$(".next-step.step2").focus(); // Focus on Continue button
		}
	});
	
	const inputs = document.getElementById("otp-div1");
	
	// Handle key events
	inputs.addEventListener("keyup", function (e) {
		const target = e.target;
		const key = e.key.toLowerCase();
	
		if (key === "backspace" || key === "delete") {
			target.value = "";
			const prev = target.previousElementSibling;
			if (prev && prev.classList.contains("otp-input")) {
				prev.focus();
			}
			return;
		}
	
		if (key === "enter") {
			const allFilled = $(".otp-input").toArray().every(input => input.value.trim().length === 1);
			if (allFilled) {
				$(".next-step.step2").click(); // Trigger click on Enter
			}
		}
	});
	
	async function loginCustomer(asd = false) {
		let formData = $("#userinputData").serialize();
		setCookie("mobileNo", $("#mobile_no").val());

		$("#grand-total-estimated-value-sticky").html(
			"+91 " + getCookie("mobileNo")
		);
		$("#mobile").val(getCookie("mobileNo"));
		return $.ajax({
			url: base_url + `/loginCustomer`,
			method: "POST",
			dataType: "json",
			data: formData,
			// headers: {
			// 	Authorization: "Bearer " + "Orange@123",
			// },
			crossDomain: true,
		})
			.then(async function (response) {
				if (response.status == 200) {
					let data = response.data;
					$("#customer_id").val(data.customer_id);
					setCookie("customerId", data.customer_id);
					// token = response.token;
					// setCookie("jwt_token", token);
					$("#otp_div").slideDown(400);
					$(".next-step").html("Continue");
					setCookie("customer_id", data.customer_id);
					// setCookie("token", data.token);

					$("#mobileError").html("");
					startTimer();
					return true;
				} else if (response.status == 400) {
					toastr.error("", response.msg);
					$("#mobileError").html(response.msg);
					return false;
				} else if (response.status == 502) {
					toastr.error("", response.msg);
					$("#mobileError").html(response.msg);
					return false;
				}
			})
			.catch(function (xhr) {
				return false;
			});
	}

	function mergeOTP() {
		return new Promise((resolve) => {
			let mergedOtp = "";
			$(".otp-input").each(function () {
				mergedOtp += $(this).val();
			});
			$("#otp").val(mergedOtp);
			resolve();
		});
	}

	async function verifyOTP() {
		await mergeOTP();
		let formData = $("#userinputData").serialize();
	
		if ($("#otp").val() == "") {
			$("#otpError").html("Please Enter OTP");
			clearOtpInputs();
			return; 
		}
	
		return $.ajax({
			url: base_url + `/verifyOTP`,
			method: "POST",
			dataType: "json",
			data: formData,
			// headers: {
			// 	Authorization: "Bearer " + "Orange@123",
			// },
			xhrFields: {
            withCredentials: true
            },
			crossDomain: true,
		})
		.then(async function (response) {
			if (response.status == 200) {
				// setCookie("jwt_token", response.token);
				$(".next-step").html("Continue");
				await getCustomerVehicleInfoNew();
				$("#mobileError").html("");
				$("#otpError").html("");
				return true;
			} else if (response.status == 400 || response.status == 502) {
				toastr.error("", response.msg);
				$("#otpError").html(response.msg);
				clearOtpInputs();
				return false;
			}
		})
		.catch(function (xhr) {
			clearOtpInputs();
			toastr.error("", "Something went wrong!");
			return false;
		});
	}
	
	// Helper function to clear OTP inputs
	function clearOtpInputs() {
		$(".otp-input").val(""); 
		$(".otp-input").first().focus(); 
	}
	

	
	let timerElement = document.getElementById("timer");
	let otpInput = document.getElementById("otp");

	let timer;
	let timeLeft = 45;

	function startTimer() {
		timeLeft = 45;
		otpInput.disabled = false;
		otpInput.value = "";

		if (timer) {
			clearInterval(timer);
		}

		timer = setInterval(() => {
			if (timeLeft <= 0) {
				clearInterval(timer);
				$("#timer").html(
					"<span class='didnt_rcv_otp'>Didn't Receive OTP ? </span><a id=\"resend\">Resend OTP</a>"
				);
			} else {
				timerElement.innerHTML = `Resend OTP in: ${timeLeft} seconds`;
			}
			timeLeft -= 1;
		}, 1000);
	}

	$("#resend_div").on("click", "#resend", function () {
		if (timeLeft <= 0) {
			clearInterval(timer);
			startTimer();
			$(".otp-input").val("");
			loginCustomer();
			toastr.success("", "OTP Successfully sent");
			$("#otpError").html("");
		}
	});






	/* ----------------12-December-2025-Dhananjay--------------------------------*/
	/* ----------------By pass Login functionality --------------------------*/


	
  //16-10-2025 by dk

function updateVehicleSummary(vehicle, customerInfo) {
	const rawModel = vehicle?.model;
	const modelText = (function () {
		if (typeof rawModel === "string") return rawModel;
		if (rawModel && typeof rawModel === "object") {
			return (
				rawModel.description ||
				rawModel.part?.description ||
				rawModel.name ||
				""
			);
		}
		return String(rawModel || "");
	})();

	let BikeName = modelText
		.toLowerCase()
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");

	// Update all the booking summary values
	selectedBikeName = modelText;
	selectedBikeImage = vehicle.image;
	selectedBikeRegNo = vehicle.reg_no;
	$("#bike_img").attr("src", 'https://cdn.shopify.com/s/files/1/0662/5751/8685/files/vehicle.svg?v=1770207477');
	$("#selected_bike_reg").text(vehicle.reg_no);
	$("#selected_bike_title").text(BikeName);
	$("#selected-bike-bottom").text(BikeName);

	$("#vehicle_id").val(vehicle.vehicle_id);
	$("#vehicle_registration_no").val(vehicle.reg_no);
	$("#vehicle_chasis_no").val(vehicle.frame_no);

	$("#bike-name").html(modelText);
	$(".bike-register-numer").html(vehicle.reg_no);
	$(".bdmd-img img").attr("src", "https://cdn.shopify.com/s/files/1/0662/5751/8685/files/vehicle.svg?v=1770207477");
	$("#bike_name_summary").text(modelText);
	$("#registration_number_summary").text(vehicle.reg_no);
	$("#bike_chasis_summary").text(vehicle.frame_no);

	// Update form data
	$("#selected_vehicle_name").val(BikeName);
	$("#selected_vehicle_img").val(vehicle.image);

	// Persist selection for reload continuity
	_persistVehicleSelection({
        vehicle_id: vehicle.vehicle_id,
        model: modelText,
        image: vehicle.image,
        reg_no: vehicle.reg_no,
        frame_no: vehicle.frame_no,
        customer_id: vehicle.customer_id,
    }, customerInfo);  
}




/* Reschedule appointment card UI update logic  */
	$(document).on("click", ".reschedule-btn", function (event) {


		const value = getCookie("customerNoRegister");
		// console.log("customerNoRegister cookie value:", value);
		if (value === "1") {

			$(".dealer_block-outer").show();
			$("#no-vehicle-found").hide();
			console.log("Customer not registered. Redirecting to registration page.");
		}

	//return;

	const $overlay = $(".upcoming-appointment-popup-overlay");
	const $popup = $(".upcoming-appointment-popup");
	$(".bike-detail-content-section").addClass("reschedule-mode");
	event.preventDefault();
	event.stopPropagation();
	$(".dealer_block-outer").addClass("booking-summary");
	$(".add-new-bike, .bike-service-plan, .bike_chasis_no, .dealer-edit, .location_icon, #service_details_heading, #service_details_section, #remarks_section, #amc-rsa-plans, .dealer_block").hide();
	$(".booking-summary-heading").css("display", "block");
	$(".previous_dealer_details-head").addClass("active");
	$("#bike-detail-slider").css("display", "none");
	$("#single-bike-data").css("display", "none");
	$("#booking_summary").css("display", "block");
	$(".secure-box").css("display", "flex");
	$(".bike-detail-content-section").css("display", "block");
	$("#select_date_time_heading").text("Choose New Date & Time");
	$("#bike_appointment_heading").text("Reschedule Your Service Appointment");
	$(".update-appointment-btn, #reschedule-btn-action, #reschedule-btn-cancel").show();
    $(".submit-plan-btn").hide();
	

    // Close popup if open
		try {
			$popup.removeClass('show');
			$('body').removeClass('popup-open');
			setTimeout(function () {
				$overlay.css('display', 'none');
			}, 300);
		} catch (e) {}


	// Store the selected appointment context for rescheduling
	const apptIndex = $(this).data('appt-index');
	if (typeof apptIndex === 'number' && window._latestAppointmentContext && window._latestAppointmentContext.appointments) {
		const selectedAppt = window._latestAppointmentContext.appointments[apptIndex];
		if (selectedAppt) {
			window._latestAppointmentContext.appointment = selectedAppt;
		}

		if (selectedAppt) {
			window._latestAppointmentContext.appointment = selectedAppt;
			// const appointmentId =
			// 	selectedAppt?.appointment?.referenceNo ||
			// 	selectedAppt?.appointment?.id ||
			// 	"";

			// // ✅ Set into hidden field
			// $("#new_dealer_id").val(appointmentId);

			 const appointmentData = selectedAppt;

			 // ✅ Customer
			const customerId = appointmentData?.customer?.id || "";
			const customerName = appointmentData?.customer?.name?.trim() || "";

			// ✅ Dealer
			const dealerId = appointmentData?.dealer?.id || "";
			const dealerName = appointmentData?.dealer?.name || "";

			// ✅ Branch
			const branchId = appointmentData?.dealer?.branch?.id || "";
			const branchName = appointmentData?.dealer?.branch?.name || "";

			// ✅ Appointment ID
			const appointmentId =
				appointmentData?.appointment?.id ||
				appointmentData?.appointment?.referenceNo ||
				"";

			console.log("Appointment ID:", appointmentId);
			console.log("Customer:", customerId, customerName);
			console.log("Dealer:", dealerId, dealerName);
			console.log("Branch:", branchId, branchName);

			// // ✅ Set into hidden field
			$("#new_dealer_id").val(dealerId);
			$("#branch_id").val(branchId);
			$("#customer_id").val(customerId);
			$("#customer_name").val(customerName);

			console.log("Selected appointment ID:", appointmentId);
		}

	}

	// console.log('Reschedule button clicked');

	return false;
	});

// Reload page on cancel button click
$("#reschedule-btn-cancel").on("click", function (e) {
	e.preventDefault();
	e.stopPropagation();
	window.location.reload();
});

// Reschedule action
/* ---------------------------------------
   Helper: Convert dd-mm-yyyy & hh:mm
   → YYYY-MM-DDTHH:mm:00Z
--------------------------------------- */
function convertToISO(dateStr) {
  if (!dateStr) return null;

  // Expected: "dd-mm-yyyy & hh:mm"
  var parts = dateStr.split('&');
  if (parts.length !== 2) return null;

  var datePart = parts[0].trim(); // dd-mm-yyyy
  var timePart = parts[1].trim(); // hh:mm

  var d = datePart.split('-');
  var t = timePart.split(':');

  if (d.length !== 3 || t.length !== 2) return null;

  var day = d[0];
  var month = d[1];
  var year = d[2];
  var hour = t[0];
  var minute = t[1];

  return `${year}-${month}-${day}T${hour}:${minute}:00Z`;
}

/* ---------------------------------------
   Reschedule Click Handler
--------------------------------------- */
$("#reschedule-btn-action").on("click", async function (event) {

  event.preventDefault();
  event.stopPropagation();

  // 1️⃣ Get selected date from input
  var selectedDateStr = $("#date_form_id").val();

  if (!selectedDateStr) {
	toastr.error("", "Please select service date & time");
    return;
  }

  // 2️⃣ Convert to ISO format
  var isoDateTime = parseAppointmentISO_updated(selectedDateStr);

  if (!isoDateTime) {
	toastr.error("", "Invalid date format");
    return;
  }

  //return;
  // 3️⃣ Show loader
  if ($("#loaderr").length) {
    $("#loaderr").css("display", "flex");
  }

  // 4️⃣ Get dynamic appointment context
  var ctx = window._latestAppointmentContext || {};
  var appointment = ctx.appointment || {};
  var vehicle = ctx.vehicle || {};
  var appt = appointment.appointment || {};
  var dealer = appointment.dealer || {};
  var branch = dealer.branch || {};

  // Extract appointment ID
  var appointmentId = appt.id || appt.appointmentId || appointment.appointmentId || appointment.id || '';
  if (!appointmentId && appt.appointmentID) appointmentId = appt.appointmentID;
  if (!appointmentId && appt.appointment_id) appointmentId = appt.appointment_id;
  if (!appointmentId && appointment.appointmentID) appointmentId = appointment.appointmentID;
  if (!appointmentId && appointment.appointment_id) appointmentId = appointment.appointment_id;
  if (!appointmentId && appt && appt.appointment && (appt.appointment.id || appt.appointment.appointmentId)) {
    appointmentId = appt.appointment.id || appt.appointment.appointmentId;
  }
  appointmentId = String(appointmentId || '').trim();
  if (!appointmentId) {
    if (typeof toastr !== 'undefined' && toastr && toastr.error) {
      toastr.error('', 'Unable to reschedule appointment.');
    } else {
      alert('Unable to reschedule appointment.');
    }
    return;
  }

  // Get dynamic customer details
  var customerId = ($('#customer_id').val && $('#customer_id').val()) ||
    (safeGetCookie('customerId') || safeGetCookie('customer_id')) ||
    (appointment.customer && appointment.customer.id) ||
    appointment.customerId ||
    '';
  var customerName = ($('#customer_name').val && $('#customer_name').val()) ||
    (appointment.customer && appointment.customer.name) ||
    '';
  var mobile = ($('#mobile').val && $('#mobile').val()) ||
    safeGetCookie('mobileNo') ||
    (appointment.customer && appointment.customer.contact && appointment.customer.contact[0] && appointment.customer.contact[0].number) ||
    '';

  // Get dynamic dealer details
  var dealerId = dealer.id || ($('#new_dealer_id').val && $('#new_dealer_id').val()) || '';
  var dealerName = dealer.name || ($('#selected_dealer_name').val && $('#selected_dealer_name').val()) || '';
  var branchId = branch.id ||
    ($('#branch_id').val && $('#branch_id').val()) ||
    ($('#new_branch_id').val && $('#new_branch_id').val()) ||
    (safeGetCookie('branchId') || safeGetCookie('branch_id')) ||
    '1';
  var branchName = branch.name || ($('#branch_name').val && $('#branch_name').val()) || '';

  // Get communication channel (dynamic if available)
  var urlChanel = getURLParameter("chanel");
  var communicationChannel = urlChanel || "WEBSITE";

  // 5️⃣ Build payload with dynamic data
  var payload = {
    appointment: {
      dateTime: isoDateTime,
      status: "Open",
      communicationChannel: communicationChannel,
      Comments: "ONLINE APPOINTMENT",
      FollowupType: false,
      EmployeeId: 1
    },
    customer: {
      id: customerId ? parseInt(customerId, 10) || 0 : 0,
      name: customerName || '',
      contact: mobile ? [{ type: 1, number: String(mobile), isPrimary: true }] : []
    },
    dealer: {
      id: dealerId ? parseInt(dealerId, 10) || 0 : 0,
      name: dealerName || '',
      branch: {
        id: branchId ? parseInt(branchId, 10) || 0 : 1,
        name: branchName || 'Main branch'
      }
    }
  };

  const token = getCookie("jwt_token"); 
//   console.log('reschedule  token:', token);
  try {
    var url = base_url + '/appointment/' + encodeURIComponent(appointmentId) + '/update';

    var resp = await $.ajax({
      url: url,
      method: "PUT",
	  xhrFields: {
			withCredentials: true
		},

      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify(payload),
      crossDomain: true,
      xhrFields: { withCredentials: true },
      timeout: 30000
    });

    var success =
      resp &&
      resp.success === true &&
      resp.data &&
      Number(resp.data.statusCode) === 200;

    if (success) {

      // 5️⃣ Store data for success page
      sessionStorage.setItem(
        "rescheduleData",
        JSON.stringify({
          appointmentId: appointmentId, // dynamic appointment ID
          appointmentDateTime: selectedDateStr // readable format
        })
      );

      // 6️⃣ Redirect
      window.location.href =
        "https://service.tvsmotor.com/pages/booking-updated";

    } else {
      var msg =
        resp?.data?.message || "Failed to update appointment";
      toastr?.error("", msg) || alert(msg);
    }

  } catch (err) {
    var msg2 =
      err?.responseJSON?.data?.message ||
      "Failed to update appointment";
    toastr?.error("", msg2) || alert(msg2);
  } finally {
    // 7️⃣ Hide loader
    if ($("#loaderr").length) {
      $("#loaderr").css("display", "none");
    }
  }
});


 
/* ----------Fetch and render Upcoming Appointment for selected vehicle -----------*/
function updateAppointmentCardUI(appointment, vehicle) {
	const $card = $(".appointment-card");
	if ($card.length === 0) return; // No card in DOM

	if (!appointment) {
		$card.hide();
		return;
	}

	// Choose label based on status; default to Upcoming Appointment
	const status = (appointment.status || "").toUpperCase();
	// let label = "Appointment History";
	// if (["CANCELLED", "CANCELED"].includes(status)) label = "Cancelled Appointment";
	// if (["COMPLETED", "DONE"].includes(status)) label = "Completed Appointment";

	$card.find(".status-badge").html('<span class="ripple"></span> ' + 'Your Appointments');
	$card.find(".vehicle-name").text(toTitleCase(vehicle?.model || ""));
	$card.find(".reg-id").text(vehicle?.reg_no || "");

	// Attach minimal data attributes for View Detail if needed later
	$card.find(".view-detail")
		.attr("data-reference", appointment?.appointment?.referenceNo || "")
		.attr("data-datetime", appointment?.appointment?.dateTime || "")
		.attr("data-dealer", appointment?.dealer?.name || "")
		.attr("data-branch", appointment?.dealer?.branch?.name || "");

	$card.show();

	// Cache latest appointment context for View Detail popup
	window._latestAppointmentContext = { appointment: appointment, vehicle: vehicle };
}


function hasActiveAppointmentForFrame(appointments, frameNo) {
	if (!frameNo || !Array.isArray(appointments)) return false;

	return appointments.some(function (item) {
		try {
			const itemFrame = (item?.vehicle?.frameNo || "").trim();
			return itemFrame === frameNo;
		} catch (e) {
			return false;
		}
	});
}


function fetchAndRenderAppointmentForVehicle(mobileNo,first_vehicle_frame_number="") {
	// Hide card until fresh data arrives
	$(".appointment-card").hide();

	const token = getCookie("jwt_token");
	// Resolve selected vehicle for UI/context (prevents `vehicle is not defined`)
	const selectedVehicleId = (
		$("#vehicle_id").val?.() ||
		(typeof getCookie === "function" ? getCookie("vehicleId") : "") ||
		""
	)
		.toString()
		.trim();

	const knownVehicles = Array.isArray(window.allBikes) ? window.allBikes : [];
	let vehicle = null;
	if (selectedVehicleId) {
		vehicle = (knownVehicles || []).find(
			(v) => String(v?.vehicle_id || "") === String(selectedVehicleId)
		);
	}
	if (!vehicle && typeof _getCachedVehicle === "function") {
		vehicle = _getCachedVehicle();
	}
	vehicle = vehicle || {};
	const mobileNumber = (
		(typeof getCookie === 'function' ? getCookie('mobileNo') : '') ||
		$("#mobile_no").val?.() ||
		$("#mobile").val?.() ||
		""
	)
		.toString()
		.trim();

	const now = new Date();
	const y = now.getFullYear();
	function _fmtYYYYMMDD(d) {
		const yyyy = d.getFullYear();
		const mm = String(d.getMonth() + 1).padStart(2, "0");
		const dd = String(d.getDate()).padStart(2, "0");
		return `${yyyy}-${mm}-${dd}`;
	}
	// From today (when user opens website)
	const fromDate = '2026-01-01'; //_fmtYYYYMMDD(now);
	// Keep current year window (minimize impact on existing behavior)
	const toDate = `${y}-12-31`;

	// New fetch API shape (as per curl/postman)

	var nrcustomer = getCookie("customerNoRegister");
	console.log("customerNoRegister cookie value:", nrcustomer);

	let payload = {
		frameNo: first_vehicle_frame_number,
		limit: 100,
		fromDate: null,
		toDate: null
	};

	// if (nrcustomer === "1") {
    // 	payload.mobileNumber = mobileNumber;
	// }
	

	return new Promise((resolve) => {
		$.ajax({
			url: base_url + "/appointment/fetch",
			method: "POST",
			xhrFields: {
            withCredentials: true
            },
			dataType: "json",
			data: JSON.stringify(payload),
			contentType: "application/json",
			crossDomain: true,
			success: function (response) {
				try {
					
					const appts = Array.isArray(response?.data?.appointments)
						? response.data.appointments
						: Array.isArray(response?.appointments)
							? response.appointments
							: [];

					const hasExistingAppt = hasActiveAppointmentForFrame(
							appts,
							first_vehicle_frame_number
						);
						
					if (hasExistingAppt) {
						$("#apointment_status").val("1");
						$('#dealer-select-popup').prop('disabled', true);
						$("#dealer-select-popup").hide();
						$("#apt-already-exist").show();
						toastr.warning("", "Already booked, Kindly reschedule or cancel it first!");
						// console.log("Appointment already exists for this vehicle");
					}else{
						$("#apointment_status").val("0");
						$("#top-header-banner").show();
						$("#dealer-select-popup").show();
						$("#apt-already-exist").hide();
						 $('#dealer-select-popup').prop('disabled', false);
						console.log("No existing appointment for this vehicle");

						// Update text if no appointment exists for the vehicle
						$("#no_apt_found").show();
						$("#detail_fetch_loader").hide();
						$("#fetching_text").hide();
					}

					if (appts.length) {
							const nowTs = now.getTime();

							function getApptTs(a) {
								try {
									const iso = a && a.appointment && a.appointment.dateTime;
									const d = iso ? new Date(iso) : null;
									const ts = d && !isNaN(d.getTime()) ? d.getTime() : null;
									return ts;
								} catch (e) {
									return null;
								}
							}

							// Sort list so UI order is consistent: upcoming first (soonest first), then past (most recent first)
							const sortedAppts = (appts || []).slice().sort(function (a, b) {
								const aTs = getApptTs(a);
								const bTs = getApptTs(b);
								if (aTs === null && bTs === null) return 0;
								if (aTs === null) return 1;
								if (bTs === null) return -1;
								const aFuture = aTs >= nowTs;
								const bFuture = bTs >= nowTs;
								if (aFuture !== bFuture) return aFuture ? -1 : 1;
								if (aFuture) return aTs - bTs;
								return bTs - aTs;
							});

							// Use the first appointment from the sorted list (soonest)
							let nearestUpcoming = sortedAppts.length ? sortedAppts[0] : null;

							// Prefer vehicle details from appointment response (id/frame/reg),
							// but keep selected/cached model & image if we have them.
							let vehicleForUI = vehicle || {};
							try {
								const srcVeh = (nearestUpcoming && nearestUpcoming.vehicle) || null;
								if (srcVeh) {
									vehicleForUI = {
										...vehicleForUI,
										vehicle_id: srcVeh.id || vehicleForUI.vehicle_id,
										reg_no: srcVeh.registrationNo || vehicleForUI.reg_no,
										frame_no: srcVeh.frameNo || vehicleForUI.frame_no,
									};
								}
							} catch (e) {}

							// Hide banner
							$("#top-header-banner").hide();
							updateAppointmentCardUI(nearestUpcoming, vehicleForUI);

							// Check appointment  already exists 

							
							// Cache full list for popup accordion (keep same ordering used by UI)
							window._latestAppointmentContext = {
								appointment: nearestUpcoming,
								appointments: sortedAppts,
								vehicle: vehicleForUI
							};
					} else {
						updateAppointmentCardUI(null, vehicle);
							window._latestAppointmentContext = { appointment: null, appointments: [], vehicle: vehicle };
					}
				} catch (e) {
					updateAppointmentCardUI(null, vehicle);
						window._latestAppointmentContext = { appointment: null, appointments: [], vehicle: vehicle };
				}
				resolve();
			},
			error: function (xhr, status, error) {

				console.error("Appointment fetch error:", xhr);

				let message = "Something went wrong. Please try again.";

				if (xhr.status === 500) {
					
					$('#dealer-select-popup').prop('disabled', true);
					$("#top-header-banner").show();
					$("#fetching_text").hide();
					$('#fetch-error').show()
					$("#detail_fetch_loader").hide();
					$('#try_agian_fatch_appointment').show()
					message = "Fetch Appointment Failed  due to server error.";
				} 
				else if (xhr.status === 401) {
					$('#dealer-select-popup').prop('disabled', true);
					$("#top-header-banner").show();
					$("#fetching_text").hide();
					$('#fetch-error').show()
					$("#detail_fetch_loader").hide();
					$('#try_agian_fatch_appointment').show()
					message = "Session expired. Please login again.";
				} 
				else if (xhr.status === 403) {
					$('#dealer-select-popup').prop('disabled', true);
					$("#top-header-banner").show();
					$("#fetching_text").hide();
					$('#fetch-error').show()
					$("#detail_fetch_loader").hide();
					$('#try_agian_fatch_appointment').show()
					message = "You are not authorized to access this.";
				} 
				else if (xhr.status === 0) {
					$('#dealer-select-popup').prop('disabled', true);
					$("#top-header-banner").show();
					$("#fetching_text").hide();
					$('#fetch-error').show()
					$("#detail_fetch_loader").hide();
					$('#try_agian_fatch_appointment').show()
					message = "Network error. Please check your internet connection.";
				}

				// toastr.error("", message);

				updateAppointmentCardUI(null, vehicle);
				window._latestAppointmentContext = { 
					appointment: null, 
					appointments: [], 
					vehicle: vehicle 
				};

				resolve();
			},

		});
	});
}

function formatAppointmentDateTime(isoString) {
	if (!isoString) return "";

	const d = new Date(isoString); // Do NOT add Z

	if (isNaN(d.getTime())) return "";

	const day = d.getDate();

	const ord = (n) => {
		const s = ["th", "st", "nd", "rd"];
		const v = n % 100;
		return n + (s[(v - 20) % 10] || s[v] || s[0]);
	};

	const month = d.toLocaleString("en-US", {
		month: "long"
	});

	const year = d.getFullYear();

	let hours = d.getHours();
	const minutes = d.getMinutes().toString().padStart(2, "0");

	const ampm = hours >= 12 ? "PM" : "AM";
	hours = hours % 12 || 12;

	return `${ord(day)} ${month} ${year} | ${hours}:${minutes} ${ampm}`;
}



function populateUpcomingAppointmentPopup(appointment, vehicle, appointments) {
	// Fill popup fields using IDs added in snippet
	const $overlay = $(".upcoming-appointment-popup-overlay");
	const $popup = $(".upcoming-appointment-popup");
	const $list = $popup.find('.appointment-list');

	// Normalize appointments array (backwards compatible)
	let apptList = [];
	if (Array.isArray(appointments)) {
		apptList = appointments;
	} else if (Array.isArray(appointment)) {
		apptList = appointment;
	} else if (appointment) {
		apptList = [appointment];
	}

	function safeText(v) {
		return (v === null || v === undefined) ? '' : String(v);
	}

	function buildDealerTitle(a) {
		const d = (a && a.dealer) || {};
		const b = (d && d.branch) || {};
		return [d.name, b.name].filter(Boolean).join(' – ');
	}

	function buildAccordionHtml(list, veh) {
		if (!Array.isArray(list) || list.length === 0) return '';
		let html = '';
		list.forEach(function (a, idx) {
			const ap = (a && a.appointment) || {};
			const v = (a && a.vehicle) || {};
			const dtLabel = formatAppointmentDateTime(ap.dateTime);
			const headerText = `Appointment Detail` + (dtLabel ? ` — ${dtLabel}` : '');
			const dealerTitle = buildDealerTitle(a);
			const dealerAddress = safeText(a && a.dealerAddress) || safeText($('#last-service-dealer-add').text());
			const dealerHours = safeText(a && a.dealerHours);
			const dealerPhone = safeText(a && a.dealerPhone);
			const mapLink = safeText(a && a.mapLink);
			const da = (a && a.dealer) || {};
			
			// First accordion item keeps existing IDs (for backward compatibility)
			const useIds = idx === 0;
			
			// Prefer veh (passed vehicle) if it has model data; fall back to v (appointment-specific vehicle)
			const vehicleForThis = (veh && veh.model) ? veh : ((v && Object.keys(v).length) ? v : (veh || {}));
			const vehicleName = safeText(vehicleForThis && (vehicleForThis.model || vehicleForThis.modelName));
			const regNo = safeText(vehicleForThis.reg_no || vehicleForThis.registrationNo || v.registrationNo);
			const frame = safeText(vehicleForThis.frame_no || vehicleForThis.frameNo || v.frameNo);
		
			html += `
			  
				<h3 class="appointment-list-header ${idx === 0 ? 'active' : ''}">${headerText}
					<span class="appointment-detail-icon">
						<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0.833008 0.833344L5.83301 5.83334L10.833 0.833344" stroke="#4A5565" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</span>
				</h3>
				<div class="appointment-detail appointment-detail-content" style="height:${idx === 0 ? 'max-content' : '0px'}">
					<div class="section-outer">
						<h4>Appointment Detail</h4>
						<div class="section-box">
							<p ${useIds ? 'id="popup-appointment-datetime"' : ''}>${dtLabel || '&nbsp;'}</p>
						</div>
					</div>
					<div class="section-outer">
						<h4>Vehicle Detail</h4>
						<div class="section-box">
							<h3 ${useIds ? 'id="popup-vehicle-name"' : ''}>${toTitleCase(vehicleName) || ''}</h3>
							<p>Registration Number: <strong ${useIds ? 'id="popup-vehicle-reg" style="color:#E7000B;"' : 'style="color:#E7000B;"'}>${regNo}</strong></p>
							<p>Chassis Number: <strong ${useIds ? 'id="popup-vehicle-frame"' : ''}>${frame}</strong></p>
						</div>
					</div>
					<div class="section-outer">
						<h4>Dealer Detail</h4>
						<div class="section-box">
							<h3 ${useIds ? 'id="popup-dealer-name"' : ''}>${toTitleCase(dealerTitle) || ''}</h3> 
							<p ${useIds ? 'id="popup-dealer-address"' : ''}>${dealerAddress || ''}</p>
						</div>
					</div>

					<button type="button" class="reschedule-btn" data-appt-index="${idx}">Reschedule</button>
					<a href="#" class="cancel-link" data-appt-index="${idx}">Cancel Appointment?</a>
				</div>
				
					
			`;
		});
		return html;
	}

	if (!appointment && (!apptList || apptList.length === 0)) {
		// No appointment: show minimal info or keep hidden
		$("#popup-appointment-datetime").text("");
		$("#popup-vehicle-name").text(toTitleCase(vehicle?.model || ""));
		$("#popup-vehicle-reg").text(vehicle?.reg_no || "");
		$("#popup-vehicle-frame").text(vehicle?.frame_no || "");
		$("#popup-dealer-name").text("");
		$("#popup-dealer-address").text("");
		$("#popup-dealer-hours").text("");
		$("#popup-dealer-phone").text("");
		$("#popup-map-link").attr("href", "javascript:void(0)");
		if ($list && $list.length) {
			$list.find('.appointment-list-header').text('Your Appointments');
		}
		return;
	}

	// Render all appointments into accordion (if multiple)
	if ($list && $list.length && apptList.length) {
		$list.html(buildAccordionHtml(apptList, vehicle || {}));
		// Keep popup title consistent
		$popup.find('.popup-header h3').text('Your Appointments');
		return;
	}

	const appt = (appointment && appointment.appointment) || {};
	const dealer = (appointment && appointment.dealer) || {};
	const branch = dealer.branch || {};

	// Use appointment-specific vehicle when available, otherwise fallback to passed `vehicle`
	const vehicleForPopup = (appointment && appointment.vehicle) ? appointment.vehicle : (vehicle || {});

	$("#popup-appointment-datetime").text(formatAppointmentDateTime(appt.dateTime));
	$("#popup-vehicle-name").text(toTitleCase(vehicleForPopup?.model || vehicleForPopup?.modelName || ""));
	$("#popup-vehicle-reg").text(vehicleForPopup?.reg_no || vehicleForPopup?.registrationNo || appt.registrationNo || "");
	$("#popup-vehicle-frame").text(vehicleForPopup?.frame_no || vehicleForPopup?.frameNo || appt.frameNo || "");

	const dealerTitle = [dealer.name, branch.name].filter(Boolean).join(" – ");
	$("#popup-dealer-name").text(toTitleCase(dealerTitle));

	// Optional fields not present in API; keep blank unless available
	$("#popup-dealer-address").text(appointment && appointment.dealerAddress ? appointment.dealerAddress : "");
	$("#popup-dealer-hours").text(appointment && appointment.dealerHours ? appointment.dealerHours : "");
	$("#popup-dealer-phone").text(appointment && appointment.dealerPhone ? appointment.dealerPhone : "");
	$("#popup-map-link").attr("href", (appointment && appointment.mapLink) ? appointment.mapLink : "javascript:void(0)");
}

// Keep most recent odometer reading
window._currentOdometer = window._currentOdometer || null;
	/* -------------Fetch Previous Dealer Information -------------------*/

	async function  fetchPreviousDealer(frameNo) {
		
		const token = getCookie("jwt_token");
		$.ajax({
			url: base_url + "/service/last-service",
			method: "GET",
			xhrFields: {
   				 withCredentials: true
			},
			data: {
			frameNo: frameNo
			},
		})
			.then(function (res) {
			if (!res || !res.jobCard) {
				$("#lastService").html("<p>No service history found</p>");
				return;
			}

			const jc = res.jobCard;
			const dealer = res.dealer;
			const customer = res.customer; 

			// ✅ Address handling (safe)
			let dealerAddressText = "-";
			if (
				customer &&
				customer.address &&
				customer.address.length > 0
			) {
				const addr = customer.address[0];
				dealerAddressText = `${addr.addressLine1} ${addr.city} - ${addr.pincode}`;
			}


			
			// ✅ Set dealer info
			$("#last-service-dealer-name").text(toTitleCase(dealer.name));
			// $("#last-service-dealer-add").text(toTitleCase(dealerAddressText));
			$(".last-service-info").text(`Last Service km: ${jc.kilometer}`);
			$(".km-notes").attr("data-last-km", jc.kilometer);
			$("#branch_id").val(dealer.branch.id);
			$("#last-service-dealer-add").hide();
			$(".tvs-dealer-item").addClass("active");

			// Show KM Notes 
			$(".km-notes").show();
			// Set Dealer Data in bootom baar 
			$("#dealer_name_summary_sticky_baar").text(toTitleCase(dealer.name));

			// Hide  skeleton loader
			 $('.dealer-card.skeleton').hide();
			 // remove disabled from book service button
			

			//  Set Dealer data in selectcted 
			selectedDealerName = $('#selected_dealer_name').val(toTitleCase(dealer.name));
			selectedDealerId = $('#new_dealer_id').val(dealer.id);
			$(".dealer_radio").val(dealer.id);

			$(".dealer_contact_info-service-time").show();
			$(".last-service-dealer").show();
            $("#dealer-select-popup").removeClass("no_last_service_dealer");
            $(".select-dealer-box").removeClass("no_last_service_dealer");


			// ✅ Service details
			$("#lastService").html(`
				<h4>Last Service Details</h4>
				<p><b>Dealer:</b> ${toTitleCase(dealer.name)}</p>
				<p><b>Address:</b> ${dealerAddressText}</p>
				<p><b>Service Type:</b> ${jc.serviceType.description}</p>
				<p><b>Kilometer:</b> ${jc.kilometer}</p>
				<p><b>Closed Date:</b> ${new Date(jc.closedDate).toLocaleDateString()}</p>
				<p><b>Status:</b> ${jc.status}</p>
			`);
			})
			.catch(function () {

				console.error("Failed to fetch previous dealer information");

				// Reset dealer search data
				resetDealerState();

				// Reset  job card and last km if last service dealer info fetch fails
				window.selectedKmRangeMaxKm = null;
    			resetJobcardConfigurations();  
				$(".km-notes").show();

				// Ensure last-km is cleared (DOM + jQuery cache) so validation won't use stale value
				$('.km-notes').removeData('last-km');
				$('.km-notes').attr('data-last-km', '');

				$("#kmErrorMsg").hide();
				$(".km-notes").hide();
				$(".last-service-info").text("");

				$("#dealer-select-popup").addClass("no_last_service_dealer");
				$(".dealer-card.skeleton").hide();
				// Hide time  if api no response
				$(".dealer_contact_info-service-time").hide();
				// Show proper message section instead of hiding everything
				$("#last-service-dealer-name")
					.show()
					.text("No dealer history found! please enter your nearby pincode");

				$(".tvs-dealer-section1 .tvs-dealer-item").removeClass("active");
				$(".tvs-dealer-section1 .tdi-image").hide();
				$(".tvs-dealer-section1 .select-dealer-box").addClass("no_last_service_dealer");	
				$("#lastService").html("<p>No service history found</p>");
				$(".last-service-dealer").hide();
			});

	}




/*---------------Get Vehicle Information update from DMS ----------------*/
function getCustomerVehicleInfoNew(urlFrameNo) {

	const token = getCookie("jwt_token");
	//  console.log('token in vehicle fetch:', token);

	$("#loaderr").css("display", "flex");
	$("#logged_number").text("+91 " + getCookie("mobileNo"));
	return new Promise((resolve) => {
		const mobileFromCookie = getCookie("mobileNo");
		const mobileFromInput = $("#mobile_no").val();
		const mobileNo = (mobileFromCookie || mobileFromInput || "").toString().trim();

		let frameNo;
		if (urlFrameNo) {
			frameNo = urlFrameNo;
		} else {
			frameNo = ($("#chasis-number").val() || "").toString().trim();
		}
		const registrationNo = (
			$("#vehicle_registration_no").val() ||
			$("#reg_no").val?.() ||
			""
		)
			.toString()
			.trim();

		const payload = {
			mobileNo: mobileNo,
			frameNo: frameNo,
			registrationNo: registrationNo,
		};

		$.ajax({
			url: base_url + "/vehicle/fetch",
			method: "POST",
			xhrFields: {
            withCredentials: true
            },
			dataType: "json",
			data: JSON.stringify(payload),
			contentType: "application/json",
			crossDomain: true,
			success: async function (response) {
				try {
					if (
						response &&
						response.success === true &&
						response.data &&
						Array.isArray(response.data.vehicle) &&
						response.data.vehicle.length > 0
					) {
						setCookie("customerNoRegister", "0");
						const rawVehicles = response.data.vehicle;
						const customerInfo = response.data.customer || {};
						const customerName = toTitleCase(customerInfo.name || "");
						const customerId = customerInfo.id || "";

						// Set customer info in hidden fields for later use
						$("#customer_name").val(customerName);
						$("#customer_id").val(customerId);
						if (customerId) setCookie("customerId", customerId);
						$(".customer-name").text('Hi ' + customerName);
						const vehicles = rawVehicles.map((v) => {
							const modelFallback =
								v.registrationNo ||
								v.frameNo ||
								(v.vehicleType && v.vehicleType.type
									? v.vehicleType.type + " Vehicle"
									: "TVS Vehicle");

							const modelText = (function () {
								if (v.series && typeof v.series === "string") return v.series;
								if (typeof v.model === "string") return v.model;
								if (v.model && typeof v.model === "object") {
									return (
										v.model.description ||
										v.model.part?.description ||
										v.model.name ||
										""
									);
								}
								return "";
							})();
							return {
								vehicle_id: v.id || v.vehicle_id || "",
								model: modelText || modelFallback,
								image: v.image || "",
								reg_no: v.registrationNo || "",
								frame_no: v.frameNo || "",
								series: v.series || ""
							};
						});

						$(".no-vehicle-found").hide();
						$("#bike-details-step-two").show();
						$(".dealer_block-outer").show();
						$(".previous_dealer_details-head").hide();
						$(".book_tvs_service_main").hide();
						let vehiclesHTML = "";
						$(".bike-detail-content-section").hide();
						$(".bd-title").show();
						$(".arro-toggle.vehicle-toggle").show();
						$(".common-header-block").show();
						$()

							vehicles.forEach((vehicle, index) => {
							const isFirst = index === 0 ? 'checked="checked"' : "";
							vehiclesHTML += `
							<div class="item" id="multiple_bike_selection">
								<input type="radio" name="bike-details" class="vehicle-select-radio" ${isFirst}>
								<label></label>
								<div class="bike_details">
									<div class="bike-detail-left">
										<div class="image_wrapper veh_img">
											<img src="https://cdn.shopify.com/s/files/1/0662/5751/8685/files/vehicle.svg?v=1770207477" alt="${vehicle.model}">
										</div>
										<span class="vehicleID" style="display: none;">${vehicle.vehicle_id}</span>
									</div>
									<div class="bike_name_deatils">
										<h2 class="bike_name_title">TVS ${toTitleCase(vehicle.model)}</h2>
										<div class="bk-detail">
											<div class="bike_no">
												<p>Registration Number: </p>
												<h4 class="veh_regNo">${vehicle.reg_no}</h4>
											</div>
											<div class="bike_chasis_no">
												<p>Chassis Number: </p>
												<h4 class="veh_chaNo">${vehicle.frame_no}</h4>
											</div>
											<input type="hidden" class="ve_customer_name" value="${customerName}">
											<input type="hidden" class="ve_customer_id" value="${customerId}">
										</div>
									</div>
									</div>
								</div>`;
						});

						$("#bike-detail-slider").html(vehiclesHTML);
						var first_vehicle_frame_number = vehicles[0].frame_no;

						await fetchPreviousDealer(first_vehicle_frame_number);

						// Keep global compatibility with thumbnail click logic
						window.allBikes = vehicles;

						console.log('Add new vehicle krne pe yanhi pe aa raha hai ')
						_persistVehicleSelection(vehicles[0],customerInfo);
						updateVehicleSummary(vehicles[0],customerInfo);

						// Fetch and render appointment for first vehicle
						fetchAndRenderAppointmentForVehicle(mobileNo, first_vehicle_frame_number);
						$("#loaderr").css("display", "none");
					} else {
						setCookie("customerNoRegister", "1");
						const cachedFrameNo = getCookie("vehicleFrameNo") || "";
						if (cachedFrameNo) {
							fetchAndRenderAppointmentForVehicle(mobileNo, cachedFrameNo);
						}
    
						// fetchAndRenderAppointmentForVehicle(mobileNo);
						// If API returns empty but we have a recently added vehicle cached, restore it
						const restored = _renderVehicleFromCacheIfAvailable(mobileNo);
						if (!restored) {
							// console.log("No vehicle found in response");
							$("#no-vehicle-found").show();
							$(".book_tvs_service_main").hide();
							$(".no-vehicle-found").show();
							$(".common-header-block").show();
						}
						$("#loaderr").css("display", "none");
					}
				} catch (e) {
					setCookie("customerNoRegister", "1");
					const restored = _renderVehicleFromCacheIfAvailable(mobileNo);
					if (!restored) {
						$("#no-vehicle-found").show();
					}
					$("#loaderr").css("display", "none");

				}
				resolve();
			},
			error: function () {
				setCookie("customerNoRegister", "1");
				const mobileFromCookie = getCookie("mobileNo");
				const mobileFromInput = $("#mobile_no").val();
				const mobileNo = (mobileFromCookie || mobileFromInput || "").toString().trim();
				const restored = _renderVehicleFromCacheIfAvailable(mobileNo);
				if (!restored) {
					$("#no-vehicle-found").show();
				}
				resolve();
				$("#loaderr").css("display", "none");

			},
		});
	});
}

	// Date - 09-December-2024, Monday
	// Author - OM_Ketan
	// Topic - Vehical Addition

	function regisvalidateForm() {
		let isChasisNumberFilled = $("#chasis-number").val().trim() !== "";
		let isTnCChecked = $("#regis_chasis_number_tnc").is(":checked");

		if (isChasisNumberFilled && isTnCChecked) {
			$("#add-new-vechicle").prop("disabled", false);
		} else {
			$("#add-new-vechicle").prop("disabled", true);
		}
	}

	// Trigger validation when the input or checkbox changes
	$("#chasis-number, #regis_chasis_number_tnc").on(
		"input change",
		function () {
			regisvalidateForm();
		}
	);

	$("#add-new-vechicle").on("click", function () {

		// Show skeleton loader while Dealer Details
		$(".dealer-card.skeleton").show();

		// Show Loader while fetching appointment details
		$("#top-header-banner").show();
		$("#detail_fetch_loader").show();
		$("#fetching_text").show();
		$("#no_apt_found").hide();
		$('#dealer-select-popup').prop('disabled', true);

		const $btn = $(this);
		$btn.prop("disabled", true);
		window.scrollTo({
			top: 0
		});
		fetchVehicleFromAppointmentApiAndRender()
			.then(function (result) {
				if (result === "NO_VEHICLE") {
					// Hide  loader if bike not found and show proper message
					$("#top-header-banner").hide();
					$("#detail_fetch_loader").hide();
					$("#fetching_text").hide();
					$('.dealer-card.skeleton').hide();
					// Do nothing (already handled inside function)
					return;
				}

				if (!result) {
					// Hide  loader if bike not found and show proper message
					$("#top-header-banner").hide();
					$("#detail_fetch_loader").hide();
					$("#fetching_text").hide();
					$('.dealer-card.skeleton').hide();

					toastr.error("", "Something went wrong. Please try again.");
				}
			})
			.catch(function () {
				// Hide  loader if bike not found and show proper message
				$("#top-header-banner").hide();
				$("#detail_fetch_loader").hide();
				$("#fetching_text").hide();
				$('.dealer-card.skeleton').hide();
				toastr.error("", "An error occurred while fetching vehicle details.");
			})
			.finally(function () {
				// Hide  loader if bike not found and show proper message
				$("#top-header-banner").hide();
				$("#detail_fetch_loader").hide();
				$("#fetching_text").hide();
				$('.dealer-card.skeleton').hide();
				$btn.prop("disabled", false);
				$("body").removeClass("overflow-hidden");
			});
	});

	function _normalizeVehicleLookupValue(v) {
		return String(v || "").replace(/\s+/g, "").toUpperCase();
	}

	function _isLikelyRegistrationNo(v) {
		// Common Indian registration patterns like KL49F3055, TN57A6876, etc.
		return /^[A-Z]{2}\d{1,2}[A-Z]{1,3}\d{1,4}$/.test(v);
	}

	function fetchVehicleFromAppointmentApiAndRender() {
	return new Promise((resolve) => {
		const lookup = _normalizeVehicleLookupValue($("#chasis-number").val());
		if (!lookup) return resolve(false);

		const mobileFromCookie = getCookie("mobileNo");
		const mobileFromInput = $("#mobile_no").val();
		const mobilenumber = (mobileFromCookie || mobileFromInput || "")
			.toString()
			.trim();

		const payload = {};
		if (_isLikelyRegistrationNo(lookup)) payload.registrationNo = lookup;
		else payload.frameNo = lookup;
		if (mobilenumber) payload.mobilenumber = mobilenumber;

		const url = base_url + "/vehicle/fetch";
		const fallbackImage =
			"https://cdn.shopify.com/s/files/1/0662/5751/8685/files/vehicle.svg?v=1770207477";

		if ($("#loaderr").length) $("#loaderr").css("display", "flex");

		$.ajax({
			url,
			method: "POST",
			dataType: "json",
			// headers: {
			// 	Authorization: "Bearer " + (getCookie("jwt_token") || ""),
			// },
			crossDomain: true,
			xhrFields: {
				withCredentials: true
			}, 
			data: JSON.stringify(payload),
			contentType: "application/json",

			success: async function (response) {
				try {
					const vehiclesRaw = Array.isArray(response?.data?.vehicle)
						? response.data.vehicle
						: [];

					const customerInfo = response?.data?.customer || {};

					if (!vehiclesRaw.length) {

						// Hide  loader if bike not found and show proper message
						$("#top-header-banner").hide();
						$("#detail_fetch_loader").hide();
						$("#fetching_text").hide();

						toastr.error("", "No vehicle found with the provided details.");

						$("#loaderr").hide();
						$('.dealer-card.skeleton').hide();
						return resolve("NO_VEHICLE"); 
					}

					/* ===============================
					   NORMALIZE VEHICLE DATA
					================================ */
					const fetchedBikes = vehiclesRaw.map((v) => ({
						vehicle_id: v.id,
						series: v.series || "",
						model:
							v.model?.description ||
							v.model?.part?.description ||
							"TVS Vehicle",
						reg_no: v.registrationNo || "",
						frame_no: v.frameNo || "",
						image: v.image || fallbackImage,
						customer_id: customerInfo.id || "",
					}));

					/* ===============================
					   MERGE WITH EXISTING BIKES
					================================ */
					if (!Array.isArray(window.allBikes)) {
						window.allBikes = [];
					}

					const newBikes = fetchedBikes.filter(
						(nb) =>
							!window.allBikes.some(
								(ob) => ob.frame_no === nb.frame_no
							)
					);

					if (!newBikes.length) {
						 toastr.warning("", "This vehicle is already added.");
						$("#loaderr").hide();
						return resolve("DUPLICATE");
					}

					window.allBikes.push(...newBikes);

					const newBike = newBikes[0]; // recently added bike

					/* ===============================
					   CUSTOMER INFO
					================================ */
					$("#customer_name").val(customerInfo.name || "");
					$("#customer_id").val(customerInfo.id || "");

					if (customerInfo.name) {
						$(".customer-name").text("Hi " + toTitleCase(customerInfo.name));
					}

					if (mobilenumber) {
						$("#logged_number").text("+91 " + mobilenumber);
					}

					/* ===============================
					   APPEND MAIN BIKE SLIDER
					================================ */
					$("#bike-detail-slider").append(`
						<div class="item" data-frame="${newBike.frame_no}">
							<input type="radio" name="bike-details" class="vehicle-select-radio" checked>
							<label></label>
							<div class="bike_details">
								<div class="bike-detail-left">
									<div class="image_wrapper veh_img">
										<img src="${newBike.image}" alt="${newBike.model}">
									</div>
									<span class="vehicleID" style="display:none;">${newBike.vehicle_id}</span>
								</div>
								<div class="bike_name_deatils">
									<h2 class="bike_name_title">TVS ${toTitleCase(newBike.series)}</h2>
									<div class="bk-detail">
										<div class="bike_no">
											<p>Registration Number:</p>
											<h4 class="veh_regNo">${newBike.reg_no}</h4>
										</div>
										<div class="bike_chasis_no">
											<p>Chassis Number:</p>
											<h4 class="veh_chaNo">${newBike.frame_no}</h4>
										</div>
										<input type="hidden" class="ve_customer_name" value="${toTitleCase(customerInfo.name)}">
										<input type="hidden" class="ve_customer_id" value="${customerInfo.id}"> 
									</div>
								</div>
							</div>
						</div>
					`);

					/* ===============================
					   APPEND THUMBNAIL
					================================ */
					$(".select-bike .active").removeClass("active");

					$(".select-bike").append(`
						<div class="bike-img-box active"
							data-vehicle-id="${newBike.vehicle_id}"
							data-frame="${newBike.frame_no}"
							data-image="${newBike.image}">
							<img src="${newBike.image}" alt="${newBike.model}">
						</div>
					`);

					/* ===============================
					   SELECT NEW VEHICLE
					================================ */
					$("#vehicle_id").val(newBike.vehicle_id);
					setCookie("vehicleId", newBike.vehicle_id);
					setCookie("vehicleName", newBike.model);
					setCookie("vehicleImage", newBike.image);

					// ✅ **ADD THIS LINE** — saves BOTH vehicle + customer to cookies + localStorage
       				_persistVehicleSelection(newBike, customerInfo);

					/* ===============================
					   DOWNSTREAM CALLS
					================================ */
					if (newBike.frame_no) {
						await fetchPreviousDealer(newBike.frame_no);
					}

					updateVehicleSummary(newBike, customerInfo);
					fetchAndRenderAppointmentForVehicle(mobilenumber, newBike.frame_no);
					$('#add-new-bike-popup').hide();
					$('body').removeClass('overflow-hidden');
					$("#loaderr").hide();

					

					// Reset form fields after successful vehicle addition
					$("#regis_chasis_number_tnc").prop("checked", false);
					$("#chasis-number").val("");

					// Ensure vehicle-info UI is visible (mirror other code paths)
					try {
						$("#non-existing-user").hide();
						$("#no-vehicle-found").hide();
						$(".no-vehicle-found").hide();
						$("#bike-details-step-two").show();
						$(".dealer_block-outer").show();
						$(".previous_dealer_details-head").hide();
						$(".bike-detail-content-section").hide();
						$(".bd-title").show();
						$(".arro-toggle.vehicle-toggle").show();
						$(".book_tvs_service_main").hide();
						$(".common-header-block").show();
					} catch (e) {}

					// Set current step to vehicle selection and persist
					try {
						currentStep = 1;
						setCookie("currentStep", currentStep);
						showStep(currentStep);
					} catch (e) {}
					resolve(true);
				} catch (err) {
					console.error("Vehicle render error:", err);
					toastr.error("", "Failed to add vehicle. Please try again.");
					$("#loaderr").hide();
					resolve(false);
				}
			},

			error: function () {
				$("#loaderr").hide();
				resolve(false);
			},
		});
	});
}


/* ===============================
   Reset Dealer and Jobcard related info when new vehicle is selected or added to avoid any mismatch in data
================================ */
	var changedDealerData = {};      // existing declaration
	function resetDealerState() {
		// reset the JS object used later in .btn-dealer-select handler
		changedDealerData = {};

		// clear hidden inputs / cookies
		$("#new_dealer_id").val("");
		$("#selected_dealer_name").val("");
		$("#branch_id").val("");

		// clear summary bar
		$("#dealer_name_summary_sticky_baar").text("");
		$("#dealer_address_step3").text("");

		// hide the pieces of UI that show dealer info
		$(".dealer_contact_info-service-time, .last-service-dealer, .pdd_image_box").hide();

		// remove any active highlight on dealer tiles
		$(".tvs-dealer-section1 .tvs-dealer-item").removeClass("active");
		$(".tvs-dealer-section .tvs-dealer-item").remove();

		// wipe out pin‑code search results and input
		$(".tvs-dealer-section").empty();
		$("#bs-pincode_search").val("");
		$(".form_group #pincodeError").hide();

		// clean up any flags on the popup
		$("#dealer-select-popup").removeClass("no_last_service_dealer");
	}



	
	// Date - 06-January-2025, Monday
	// Author - OM_Ketan
	// Topic - Swipe Detection and De-Selecting the selected elements on Swipe

	$(document).on("click", ".item, #multiple_bike_selection", async function (e) {

		 e.preventDefault();
   		 e.stopPropagation();

		window.selectedKmRangeMaxKm = null;
    	resetJobcardConfigurations();

		// reset dealer/search state
    	resetDealerState();

	// Show loading state in appointment card while fetching data for selected vehicle
	$("#top-header-banner").show();
	$("#detail_fetch_loader").show();
	$("#fetching_text").show();
	$("#no_apt_found").hide();


	// Uncheck all radios
	$(".vehicle-select-radio").prop("checked", false);

	// Check current radio
	let radio = $(this).find(".vehicle-select-radio");
	radio.prop("checked", true);

	// Get bike info from clicked item
	let vehicle = {
		model: $(this).find(".bike_name_title").text(),
		image: $(this).find(".veh_img img").attr("src"),
		vehicle_id: $(this).find(".vehicleID").text(),
		reg_no: $(this).find(".veh_regNo").text(),
		frame_no: $(this).find(".veh_chaNo").text(),
		selected_ve_customer_name: $(this).find(".ve_customer_name").val(),
		selected_ve_customer_id: $(this).find(".ve_customer_id").val(),
	};
	let customerInfo = {
		name: vehicle.selected_ve_customer_name,
		id: vehicle.selected_ve_customer_id
	};

	updateVehicleSummary(vehicle,customerInfo);
	$("#choose_vehicle_first").hide();
	// Update appointment card for this selected vehicle
	const mobileNoForAppt = (
		(typeof getCookie === "function" ? getCookie("mobileNo") : "") ||
		$("#mobile_no").val?.() ||
		$("#mobile").val?.() ||
		""
	)
		.toString()
		.trim();


		console.log('select  customer name:', vehicle.selected_ve_customer_name);
		console.log('select  customer id:', vehicle.selected_ve_customer_id);

		// Set customer info in hidden fields for later use
		$("#customer_id").val(vehicle.selected_ve_customer_id);
		$("#customer_name").val(vehicle.selected_ve_customer_name);
		$(".customer-name").text('Hi ' + toTitleCase(vehicle.selected_ve_customer_name));

		// Fetch previous dealer for this vehicle
		const frame_no = vehicle.frame_no;

		// On bike seelection show skeleton loader in appointment card until data is fetched and rendered and disable book service button
		$('#dealer-select-popup').prop('disabled', true);
		$(".dealer-card.skeleton").show();

		 // ✅ CLEAR THE OLD KM DATA BEFORE FETCHING NEW DEALER INFO
		$('.km-notes').removeData('last-km');
		$('.km-notes').data('last-km', null);
		$("#kmErrorMsg").hide();  


		/* Remove  this functiona becuse it is calling twice one on click and one on thumbnail click */		
		fetchAndRenderAppointmentForVehicle(mobileNoForAppt,frame_no); 

		// Fetch previous dealer for this vehicle
		await fetchPreviousDealer(frame_no);


});

	// Thumbnail click: highlight selected bike in #qwe (do not replace list)
	$(document).on("click", ".thumbnail-bike-img", function () {
		const selectedBikeId = $(this).parent().data("vehicle-id");
		const bikesList = Array.isArray(window.allBikes) && window.allBikes.length
			? window.allBikes
			: allBikes;
		const selectedBike = (bikesList || []).find(
			(bike) => String(bike.vehicle_id) === String(selectedBikeId)
		);
		if (!selectedBike) return;

		$(".bike-img-box").removeClass("active");
		$(this).parent().addClass("active");

		const $qwe = $("#qwe");
		if (!$qwe.length) return;

		const selector = `.tvs_list_item_box[data-vehicle-id="${selectedBike.vehicle_id}"]`;
		if ($qwe.find(selector).length === 0) {
			$qwe.append(`
				<div class="tvs_list_item_box" data-vehicle-id="${selectedBike.vehicle_id}">
					<div class="tvs_bike_info">
						<h3 class="bike_modal">${selectedBike.model}</h3>
						<div class="tvs_bike_info_dec">
							<p>Registration Number</p>
							<h4 class="reg_no">${selectedBike.reg_no}</h4>
						</div>
						<div class="tvs_bike_info_dec">
							<p>Chassis Number</p>
							<h4 class="frame_no">${selectedBike.frame_no}</h4>
						</div>
					</div>
					<div class="tvs_bike_img">
						<img src="https://cdn.shopify.com/s/files/1/0662/5751/8685/files/vehicle.svg?v=1770207477" class="bike_img" id="main_bike_img">
					</div>
				</div>
			`);
		}

		$qwe.find('.tvs_list_item_box').removeClass('active');
		$qwe.find(selector).addClass('active');
	});


	$(document).on("click", ".dealer_box", function () {
		let dealerTileCheckedBox = $(this).find("input[type='radio']");

		if (dealerTileCheckedBox.prop("checked")) {
			dealerTileCheckedBox.prop("checked", false);
		} else {
			dealerTileCheckedBox.prop("checked", true);
		}
	});

	$(".pdd_image_box").css("display", "none");


	// Date - 11-December-2024, Wednesday
	// Author - OM_Ketan
	// Topic - Search Dealers using PinCode

	$(document).on("input", "fieldset #pincode", function () {
		$(".form_group #pincodeError").html("");
	});

	// Pincode Validation
	$("fieldset #pincode").on("input", function () {
		let value = $(this).val();
		if (!/^\d$/.test(value) || value === "0") {
			$(this).val("");
		}
		if (value.length > 1) {
			$(this).val(value.slice(0, 6));
		}
	});

	/* ----------- Clean Dealer ID Function -----------------*/
	function trimDealerId(dealerId) {
		if (!dealerId) return "";

		// Match: 2 letters + digits + 2 digits at end
		const match = dealerId.match(/^[A-Za-z]{2}(\d+)\d{2}$/);

		return match ? match[1] : dealerId;
	}

	

	/* ---------Dealer Search function -----------------*/
	function dealer_search() {
		// Reset previous dealer search state (important when user changes vehicle selection after doing a pincode search)
		resetDealerState();

		let pincode = $("fieldset #pincode").val().trim();

		if (pincode === "") {
			$(".form_group #pincodeError").html("Please enter pincode");
			$(".form_group #pincodeError").show();
			// Disable continue button if pincode is empty
			$(".tvs_btn_group.bike-detail-box.continueBtn.tvs_inner_next_btn.yes_no_btn").prop("disabled", true);
			$(".tvs_btn_group.bike-detail-box.continueBtn.tvs_inner_next_btn.yes_no_btn").removeClass("active");
			return;
		}

		// console.log(pincode.length);

		if (!(pincode.length >= 6)) {
			$(".form_group #pincodeError").html("Please enter a valid Pincode");
			$(".form_group #pincodeError").show();
			// Disable continue button if pincode is invalid
			$(".tvs_btn_group.bike-detail-box.continueBtn.tvs_inner_next_btn.yes_no_btn").prop("disabled", true);
			$(".tvs_btn_group.bike-detail-box.continueBtn.tvs_inner_next_btn.yes_no_btn").removeClass("active");
			return;
		}
		const token = getCookie("jwt_token");
		pincode_error_flag = true;
		if (pincode_error_flag) {

			// Oct 16 dealer search comments

			//return; 
			$.ajax({
				url: base_url + "/dealer/search",
				method: "POST",
				xhrFields: {
    				withCredentials: true
				},

				contentType: "application/json",
				data: JSON.stringify({ pincode }),
				})
				.then(function (response) {
				$("#dealer-loader").hide();

				const dealers = response.dealers;
				const selectedDealers = $(".tvs-dealer-section");
				selectedDealers.empty();

				if (!dealers || dealers.length === 0) {
					selectedDealers.html("<p>No dealers found</p>");
					return;
				}

				
				// Remove Active clas and hide logic if dealer data is coming from pincode search


				$("#dealer-select-popup").removeClass("no_last_service_dealer");
				// $(".tvs-dealer-section1 .tvs-dealer-item").removeClass("active");
				// $(".tvs-dealer-section1 .tdi-image").show();
				// $(".tvs-dealer-section1 .select-dealer-box").removeClass("no_last_service_dealer");
				// $(".tvs-dealer-section1 .last-service-dealer").hide();
				

				dealers.forEach((dealer) => {
					const mapLink =
					`https://www.google.com/maps/dir/?api=1&destination=` +
					dealer.location.latitude +
					"," +
					dealer.location.longitude;

                 selectedDealers.append(`
										<div class="tvs-dealer-item">
										<input type="radio" name="delaer_radio" id="${trimDealerId(dealer.sapDealerCode)}" value="${trimDealerId(dealer.sapDealerCode)}" class="dealer_radio">
										<div class="tvs-dealer-inner">
										<div class="tdi-image"> 
										
										<div class="dealer-location-img">
											<img src="https://cdn.shopify.com/s/files/1/0662/5751/8685/files/location-new-icon.svg?v=1759734634">
										</div>
										</div>
										<div class="tdi-content">
											<div class="dealer_info">
											<h4 class="dealer_name"> ${toTitleCase(dealer.name)}</h4>
											<p class="dealer_address">${toTitleCase(dealer.address)}</p>
											</div>
											<div class="dealer_contact_info">
											<div class="dealer_contact_info-location">
											<a
												href="${mapLink}"
												style="z-index:9;"
												target="_blank"
											>
												<img src="https://cdn.shopify.com/s/files/1/0662/5751/8685/files/location-new-black-icon.svg?v=1759736752">
											
											<span>View Map</span></a>
											</div>
												<!--div class="dealer_contact_info-review">
											<img src="https://cdn.shopify.com/s/files/1/0662/5751/8685/files/review-star-icon.svg?v=1759735831"> 
											<span class="review-ratting">4.8</span>
											</div-->
											<p class="contact_no">
												<a href="tel:${dealer.contact.primaryPhoneNumber}" style="z-index:8;">
												<img src="https://cdn.shopify.com/s/files/1/0662/5751/8685/files/dealer-phone-new-icon.svg?v=1759735031">

												
													${dealer.contact.primaryPhoneNumber}
												</a>
											</p>

											<div class="dealer_contact_info-service-time">
											<img src="https://cdn.shopify.com/s/files/1/0662/5751/8685/files/service-time-icon.svg?v=1759735900"> 
											<span class="service-time-text">9:00 AM - 7:00 PM</span>
											</div>
											
											
											</div>
											<div class="service-info-section">
											<input type="hidden" name="branch_id" class="branch_id" value="${dealer.tempDmsBranchSequence}">
											</div>
										</div>
										</div>
									</div>
									`);


				});
				})
				.catch(function () {
				$("#dealer-loader").hide();
				toastr.error("Dealer fetch failed");
				});
			$("#dealer-loader").show();
		}
	}

	/* ---------Dealer Search using pincode -----------------*/
	$("fieldset #pincode_button").on("click", dealer_search);

	var changedDealerData = {};

	$(document).on("click", ".tvs-dealer-item", function () {
		// console.log("Dealer item clicked");
		var radioButton = $(this).find("input[type='radio']");
		if (radioButton.prop("checked")) {
			radioButton.prop("checked", false);
		} else {
			radioButton.prop("checked", true); 
		}

		var dealerName = $(this).find(".dealer_name").text();
		var dealerAddress = $(this).find(".dealer_address").text();
		var googleMapLink = $(this).find(".dealer_contact_info a").attr("href");
		var branchId = $(this).find(".branch_id").val();
		var dealerId_new = $(this).find(".dealer_radio").val();
		$('#selected_dealer_name').val(dealerName);
		changedDealerData.dealerId = dealerId_new;
		changedDealerData.dealerName = dealerName;
		changedDealerData.dealerAddress = dealerAddress;
		changedDealerData.googleMapLink = googleMapLink;
		changedDealerData.branchId = branchId;
		
		selectedDealerId = $("#new_dealer_id").val(changedDealerData.dealerId);
		selectedDealerBranchId = $("#branch_id").val(changedDealerData.branchId); 

		let appointmentStatus = $("#apointment_status").val();
		console.log('appointmentStatus:', appointmentStatus);
		if(appointmentStatus == 1) {
			$('#dealer-select-popup').prop('disabled', true);
		} 

		if(appointmentStatus == 0) {
			$('#dealer-select-popup').prop('disabled', false);
		} 
		

	});

		
    /* ---- click continue button after dealer selection ------*/
	
	$(".btn-dealer-select").on("click", function (e) {

		// ==== new validation ====
		const prevId = ($("#new_dealer_id").val()).toString().trim();
		const hasChanged = !!(changedDealerData && changedDealerData.dealerId);
		console.log("Continue clicked. Validation check - prevId:", prevId, "hasChanged:", hasChanged);

		if (!hasChanged && !prevId) {
			console.log('line number 2826 pe pahuncha');
			// no dealer selected from history or search
			toastr.error("", "Please select Dealer");
			e.preventDefault();
			e.stopImmediatePropagation();
			return;
		}
    // ==== end validation ====

		let pincode = $("fieldset #pincode").val().trim();
		let popupValue = $(this).attr("data-popup");
		let $checkedRadio = $(".tvs-dealer-item input[type='radio']:checked").first();
		let previousDealerId = ($("#new_dealer_id").val() || "").toString().trim();
		let previousDealerName = (
			$("#selected_dealer_name").val() ||
			selectedDealerName ||
			""
		)
			.toString()
			.trim();
		let hasDealerSelected =
			($checkedRadio.length > 0) ||
			!!(changedDealerData && changedDealerData.dealerId) ||
			previousDealerId !== "";

		// If dealer is not selected, keep user on the same step and prevent other click handlers
		if (!hasDealerSelected) {
			if (pincode === "") {
				$(".form_group #pincodeError").html("Please enter pincode").show();
			} else if (pincode.length < 6) {
				$(".form_group #pincodeError").html("Please enter a valid Pincode").show();
			} else {
				$("#choose_dealer_first").css("display", "block");
			}
			e.preventDefault();
			e.stopImmediatePropagation();
			return;
		}

		// Clear pincode error when continuing with a selected dealer
		$(".form_group #pincodeError").hide();
		$("#choose_dealer_first").css("display", "none");

		// Build dealer data robustly (searched dealer OR already-loaded previous dealer)
		let $dealerItem = $checkedRadio.length ? $checkedRadio.closest(".tvs-dealer-item") : $();
		let dealerId =
			(changedDealerData && changedDealerData.dealerId) ||
			($checkedRadio.attr("id") || "") ||
			previousDealerId;
		let dealerName =
			(changedDealerData && changedDealerData.dealerName) ||
			($dealerItem.find(".dealer_name").text() || "") ||
			previousDealerName;
		let dealerAddress =
			(changedDealerData && changedDealerData.dealerAddress) ||
			($dealerItem.find(".dealer_address").text() || "") ||
			($("#last-service-dealer-add").text() || "");
		let googleMapLink =
			(changedDealerData && changedDealerData.googleMapLink) ||
			($dealerItem.find(".dealer_contact_info a").attr("href") || "");

		$(".pdd_image_box").css("display", "flex");
		// $("#new_dealer_id").val(dealerId);
		// $("#selected_dealer_name").val(dealerName);
		$("#dealer_name_step3").html(
			dealerName
				.toLowerCase()
				.replace(/\b\w/g, function (char) {
					return char.toUpperCase();
				})
		);
		$("#dealer_address_step3").html(dealerAddress);
		if (googleMapLink) {
			$(".location_icon").attr("href", googleMapLink).attr("target", "_blank");
		}

		selectedDealerName = dealerName;
		selectedDealerAddress = dealerAddress;
		$("#dealer_name_summary_sticky_baar").text(selectedDealerName);
		if (popupValue == "1") {
			$("#add-new-dealer-popup").hide();
			$("#bookaservice-bike-summary-popup").show();
			$("#dealer_name_summary_one").text(selectedDealerName);
		} else {
			$("#add-new-dealer-popup").hide();
			$("body").removeClass("overflow-hidden");
		}
	});


	/* --------- Dealer selection active and radio button selection ----------*/
	
	$(document).on("click", ".pincode-section .tvs-dealer-item", function () {
	// sabse pehle sab items se active class hatao
	$(".pincode-section .tvs-dealer-item").removeClass("active");
	
	// current clicked item par active class lagao
	$(this).addClass("active");
	
	// uske andar radio button select bhi kar do
	$(this).find("input[type='radio']").prop("checked", true);

	// Enable continue button
	$(".tvs_btn_group.bike-detail-box.continueBtn.tvs_inner_next_btn.yes_no_btn").prop("disabled", false);
	$(".tvs_btn_group.bike-detail-box.continueBtn.tvs_inner_next_btn.yes_no_btn").addClass("active");
	});

	// <---------------------------------------------------------------------->

	// Date - 09-December-2024, Monday
	// Author - OM_Ketan
	// Topic -Appointment calender dates

	setDatesInCalender();
	async function nextStep(res = false) {
		let response = false;
		if (currentStep == 0) {
			if ($("#tnc").is(":checked")) {
				if (otp_steps == 0) {
					checkMobileNo();
					if (!mobileNoError) {
						response = await loginCustomer();

						if (response) {
							otp_steps = 1;
							$("#otp_popup").show();
							$("body").addClass("overflow-hidden");
						}
					} else {
						response = false;
					}
					return false;
				} else if (otp_steps == 1) {
					response = await verifyOTP();
					if (response) {
						otp_steps = 2;
						$("#otp_popup").hide();
						$("body").removeClass("overflow-hidden");
					}
				}
				$("#tncError").html("");
			} else {
				$("#tncError").html(
					"Please Select I Agree to the Terms and Condition"
				);
			}

			//console.log("response", response);
		} else if (currentStep == 1) {
			if ($("#vehicle_id").val() != "") {
				$(".next-step").prop("disabled", true);

				if (!res) {
					let jobCardCheck = await checkJobCard();
					if (!jobCardCheck) {
						//response = await fetchPreviousDealer();
						$("#bike-details-step-two").show();
						$(".dealer_block-outer").show();
					} else {
						return;
					}
				} else {
					//response = await fetchPreviousDealer();
					$("#bike-details-step-two").show();
					$(".dealer_block-outer").show();
				}
			} else toastr.error("", "Please select vehicle");
			//}
		} else if (currentStep == 3) {
			console.log("current step line", currentStep);

			$("#bike-details-step-two").hide();
			$(".dealer_block-outer").hide();

			let error = false;

			if ($("#date_form_id").val() == "") {
				error = true;
				$("#dateError").html("This field is required");
			} else $("#dateError").html("");

			if ($("#checkbox1").is(":checked")) {
				$("#job_card_checkmark_input").val(1);

				console.log($("#howManyKm").val());

				if (
					$("#howManyKm").val() == "" ||
					$("#howManyKm").val() == undefined
				) {
					error = true;
					$("#howManyKmError").html("This field is required");
				} else $("#howManyKmError").html("");

				if (
					$("#customerVoice").val() == "" ||
					$("#customerVoice").val() == undefined
				) {
					error = true;
					$("#customerVoiceError").html("This field is required");
				} else $("#customerVoiceError").html("");
			} else {
				$("#job_card_checkmark_input").val(0);
			}

			if ($("#time_form_id").val() == "") {
				error = true;
				$("#timeError").html("This field is required");
			} else $("#timeError").html("");

			if (
				!$("#checkbox1").is(":checked") &&
				!$("#checkbox2").is(":checked")
			) {
				error = true;
				$("#jobCardYesNo").html("Please select one");
			} else $("#jobCardYesNo").html("");

			if (error) return;

			response = await addJobCard();

			if (response) $(".next-step").html("Submit");
		} else if (currentStep == 2) {
			let zxc = $("#new_dealer_id").val();
			let today_date = $("#booking_date").val();
			await Promise.all([
				setVehiclesDetailStep3(),
				setDealerDeatilsStep3(),
			]);

			setDatesInCalender();

			if ($("#new_dealer_id").val() == "") {
				toastr.error("", "Please select Dealer");
				return;
			} else {
				let zxc = $("#new_dealer_id").val();
				console.log("zxc ->>", zxc);
			}
		} else if (currentStep == 4) {
			if (
				$("#amc").is(":checked") ||
				$("#rsa").is(":checked") ||
				$("#vas").is(":checked")
			)
				response = await updateJobCard();
		}

		if (response || currentStep == 2 || currentStep == 4) {
			if (otp_steps == 2) {
				currentStep++;
				if (currentStep < 4) {
					setCookie("currentStep", currentStep);
					setCookie("otpStep", otp_steps);
				}
			}

			//console.log("currentStep after 2 after", currentStep);
			showStep(currentStep);
		}
	}
	// Slot selection (range/API + legacy compatible)
	$(document).on("click", "#date_time_modal .slots", function (e) {
		// Prevent <a href="#"> from jumping the page
		if (e && e.preventDefault) e.preventDefault();
		if (e && e.stopPropagation) e.stopPropagation();

		// Ignore disabled slots
		if ($(this).hasClass("time-btn-slot-disable") || $(this).hasClass("disabled") || $(this).prop("disabled")) {
			return;
		}

		const $p = $(this).find(".time_slot_js");
		const slot = String($p.attr("value") || "").trim();
		if (!slot) return;
		$("#slot_id").val(slot);

		// Highlight selected time
		$("#date_time_modal .time_slot_js").removeClass("active");
		$p.addClass("active");

		// Determine selected date
		let y = window._selectedSlotDateParts?.y;
		let m = window._selectedSlotDateParts?.m;
		let d = window._selectedSlotDateParts?.d;

		// Fallback: parse from active tab's date-key (YYYY-MM-DD)
		if (!y || !m || !d) {
			try {
				const key = String($("#dates_container .date_slot.active").data("date-key") || "").trim();
				const mm = key.match(/^(\d{4})-(\d{2})-(\d{2})$/);
				if (mm) {
					y = parseInt(mm[1], 10);
					m = parseInt(mm[2], 10);
					d = parseInt(mm[3], 10);
				}
			} catch (_) {}
		}
		if (!y || !m || !d) return;

		// Format selected time
		let hours = slot.substring(0, slot.length - 2);
		let minutes = slot.substring(slot.length - 2);
		hours = String(hours).padStart(2, "0");
		minutes = String(minutes).padStart(2, "0");

		const dd = String(d).padStart(2, "0");
		const mm2 = String(m).padStart(2, "0");
		const formattedDate = `${dd}-${mm2}-${y}`;
		const formattedTime = `${hours}:${minutes}`;
		const formattedDateTime = `${formattedDate} & ${formattedTime}`;

		$("#date_form_id").val(formattedDateTime);
		$("#date_form_id").trigger("input");

		// Update summary fields if present
		try {
			$("#selected-formated-date").text(formattedDateTime);
			$("#appointment_date_summary").text(formattedDateTime);
		} catch (_) {}

		// Close popup
		$("#date_time_modal").hide();
		$("body").removeClass("overflow-hidden");
	});

	$("#dates_container").on("click", ".date_slot", function () {
		// NEW: if tabs were built from date-range API, use that map
		const key = $(this).data("date-key");
		if (key && window._slotDailyMap) {
			$(".date_slot").removeClass("active");
			$(this).addClass("active");
			_applySlotsForDateKey(String(key));
			return;
		}

		// OLD: legacy calendar behavior
		$(".slots").removeClass("time-btn-slot-disable");
		let date_selected = $(this).data("date");
		let selectedDateFormatted = formatDate(date_selected);
		$("#date_modal_selected").html(date_selected + " Available Slot");
		$(".date_slot").removeClass("active");
		$(this).toggleClass("active");
		$("#booking_date").val(selectedDateFormatted);
		//fetchSlotAvailability(selectedDateFormatted);
	});

	function getCurrentTime() {
		const now = new Date();
		const hours = now.getHours().toString().padStart(2, "0");
		const minutes = now.getMinutes().toString().padStart(2, "0");
		return parseInt(hours + minutes);
	}

	function formatDateasd(date) {
		const options = { month: "short", day: "numeric" };
		return date.toLocaleDateString("en-US", options);
	}

	function formatDate(dateString) {
		const parts = dateString.split(", ");
		const dayMonth = parts[1].split(" ");
		return `${dayMonth[0]} ${dayMonth[1]}`;
	}

	async function setDatesInCalender() {
		const numberOfDays = 30;
		const slotsAvailable = 13;
		const dateSlotsContainer = $("#dates_container");
		dateSlotsContainer.html("");

		for (let i = 0; i < numberOfDays; i++) {
			let date = new Date();

			date.setDate(date.getDate() + i);

			let options = { weekday: "long", day: "numeric", month: "short" };

			let formattedDate = date.toLocaleDateString("en-US", options);

			if (i === 0) {
				let asd = formattedDate.split(", ")[1];
				$("#booking_date").val(asd);

				let date_parts = formattedDate.split(" ");
				$("#date_modal_selected").html(
					date_parts[2] + " " + date_parts[1] + " Available Slot"
				);
			}

			let format_for_slot = formatDate(formattedDate);
			let no_of_slots = 0 ;//await fetchSlotAvailability(format_for_slot);
			no_of_slots = 21 - no_of_slots;

			let slotHtml = `
              <div class="date_slot ${
					i === 0 ? "active" : ""
				}" data-date="${formattedDate}">
                  <h3 class="date">${formattedDate}</h3>
                  <p class="slot_availability">${no_of_slots} Slots Available</p>
              </div>
          `;
			dateSlotsContainer.append(slotHtml);
		}
	}

	$("#apt-already-exist").on("click", function () {
		// console.log("You have already booked an appointment");
		toastr.warning("", "Already booked, Kindly reschedule or cancel it first!");
		
	});

	// <---------------------------------------------------------------------->

	// Date - 12-December-2024, Monday
	// Author - OM_Ketan
	// Topic - Setting the single vehicle in the footer

	/*** toggle class ***/

	$(".btn-dealer-select").on("click", function () {
		$(".bike-detail-content-section").css("display", "block");
	});
	$(".btn-dealer-select").on("click", function () {
		$(".dealer_block-outer").addClass("booking-summary");
		$(".add-new-bike, .bike-service-plan, .bike_chasis_no, .dealer-edit, .location_icon").hide();
		$(".booking-summary-heading").css("display", "block");
        $(".previous_dealer_details-head").addClass("active");


		// 14-10-2025 hide and show content by rambeer
		$("#bike-detail-slider").css("display", "none");
        $("#single-bike-data").css("display", "none");
		$("#booking_summary").css("display", "block");
		$(".secure-box").css("display", "flex");
		
    });
	$(".vpb-toggle").on("click", function () {
		$("body").addClass("overflow-hidden1");
	});

	$(".close-vpb, .btn-appointment").on("click", function () {
		$("body").removeClass("overflow-hidden1");
	});

	/*-----------------------16-December-2024-OM_Rambeer-------------------------------*/
	/*-----------------------View Upcomming Appointment  Details -----------------------*/
		$(".vpb-toggle").click(function () {
			$(".bike-detail-bottom-section-inner").toggleClass("active");
		});
		$(".close-vpb").click(function () {
			$(".bike-detail-bottom-section-inner").removeClass("active");
		});

		var $overlay = $('.upcoming-appointment-popup-overlay');
		var $popup = $('.upcoming-appointment-popup');
		var $closeBtn = $('.close-popup');
		var $cancelConfirmModal = $('.cancel-confirmation-modal');
		var $cancelConfirmYes = $('.cancel-confirmation-yes');
		var $cancelConfirmNo = $('.cancel-confirmation-no');
		var $cancelConfirmFeedback = $('.cancel-confirmation-feedback');

		// Delegate click for dynamically present links
		$(document).on('click', '.view-detail', function () {
			// console.log('[book-a-service] .view-detail clicked');
			// $("#bike-details-step-two").show();
			try {
				// Re-query overlay/popup to avoid stale selections
				const $overlayNow = $('.upcoming-appointment-popup-overlay');
				const $popupNow = $('.upcoming-appointment-popup');
				// console.log('[book-a-service] overlay/popup elements:', $overlayNow.length, $popupNow.length);
				const ctx = window._latestAppointmentContext || {};
				//  console.log('[book-a-service] popup context', ctx);
				try {
					populateUpcomingAppointmentPopup(ctx.appointment, ctx.vehicle, ctx.appointments);
				} catch (innerErr) {
					console.error('[book-a-service] populateUpcomingAppointmentPopup error', innerErr);
				}
				// Always try to show overlay/popup if elements exist
				$('body').addClass('popup-open');
				if ($overlayNow && $overlayNow.length) $overlayNow.css('display', 'flex');
				if ($popupNow && $popupNow.length) {
					setTimeout(function () { $popupNow.addClass('show'); }, 10);
				} else {
					console.warn('[book-a-service] popup element not found');
				}
			} catch (e) {
				console.error('[book-a-service] view-detail handler error', e);
			}
		});

		// Popup accordion: delegated handler so it works for dynamic appointment lists
		$(document)
			.off('click', '.upcoming-appointment-popup .appointment-list-header')
			.on('click', '.upcoming-appointment-popup .appointment-list-header', function (e) {
				e.preventDefault();
				const $header = $(this);
				const $content = $header.next('.appointment-detail-content');
				if ($content.length === 0) return;

				const isOpen = $header.hasClass('active');
				const $allHeaders = $('.upcoming-appointment-popup .appointment-list-header');
				$allHeaders.removeClass('active');
				$allHeaders.each(function () {
					const $c = $(this).next('.appointment-detail-content');
					if ($c.length) $c.css('height', '0px');
				});

				if (!isOpen) {
					$header.addClass('active');
					$content.css('height', 'max-content');
				}
			});
		function closePopup() {
			$popup.removeClass('show');
			$('body').removeClass('popup-open'); 
			// $("#bike-details-step-two").hide();
			setTimeout(function () {
			$overlay.css('display', 'none');
			}, 300);
		}

		function openCancelConfirmation() {
			try {
				if ($cancelConfirmFeedback && $cancelConfirmFeedback.length) {
					$cancelConfirmFeedback.removeClass('error').text('').hide();
				}
				if ($cancelConfirmYes && $cancelConfirmYes.length) $cancelConfirmYes.prop('disabled', false);
				if ($cancelConfirmNo && $cancelConfirmNo.length) $cancelConfirmNo.prop('disabled', false);
				if ($cancelConfirmModal && $cancelConfirmModal.length) {
					$cancelConfirmModal.attr('aria-hidden', 'false').css('display', 'flex');
				}
			} catch (e) {}
		}

		function closeCancelConfirmation() {
			try {
				if ($cancelConfirmModal && $cancelConfirmModal.length) {
					$cancelConfirmModal.attr('aria-hidden', 'true').hide();
				}
			} catch (e) {}
		}

		function safeGetCookie(name) {
			try {
				return (typeof getCookie === 'function') ? getCookie(name) : '';
			} catch (e) {
				return '';
			}
		}

		$closeBtn.on('click', closePopup);
		$overlay.on('click', function (e) {
			if (e.target === this) {
			closePopup();
			}
		});

		// Open cancel confirmation modal
		$(document).on('click', '.upcoming-appointment-popup .cancel-link', function (e) {
			e.preventDefault();
			e.stopPropagation();
			// If multiple appointments are shown, set context to the clicked one
			try {
				var idxStr = $(this).attr('data-appt-index');
				var idx = idxStr !== undefined ? parseInt(idxStr, 10) : NaN;
				var ctx = window._latestAppointmentContext || {};
				if (!isNaN(idx) && ctx && Array.isArray(ctx.appointments) && ctx.appointments[idx]) {
					ctx.appointment = ctx.appointments[idx];
					window._latestAppointmentContext = ctx;
				}
			} catch (ex) {}
			openCancelConfirmation();
		});

		// If multiple appointments are shown, keep context in sync for reschedule too
		// (handled by the global delegated .reschedule-btn handler)

		// Close confirmation on Cancel
		$(document).on('click', '.cancel-confirmation-no', function (e) {
			e.preventDefault();
			e.stopPropagation();
			closeCancelConfirmation();
		});

		// Confirm cancel -> call API
		$(document).on('click', '.cancel-confirmation-yes', async function (e) {
			e.preventDefault();
			e.stopPropagation();

			try {
				if ($cancelConfirmYes && $cancelConfirmYes.length) $cancelConfirmYes.prop('disabled', true);
				if ($cancelConfirmNo && $cancelConfirmNo.length) $cancelConfirmNo.prop('disabled', true);
				if ($cancelConfirmFeedback && $cancelConfirmFeedback.length) {
					$cancelConfirmFeedback.removeClass('error').text('Cancelling appointment...').show();
				}
			} catch (e) {}

			var redirectUrl = 'https://service.tvsmotor.com/pages/booking-cancelled';
			var ctx = window._latestAppointmentContext || {};
			var appointment = ctx.appointment || {};
			var appt = appointment.appointment || {};
			var dealer = appointment.dealer || {};
			var branch = dealer.branch || {};

			var appointmentId = appt.id || appt.appointmentId || appointment.appointmentId || appointment.id || '';
			// extra fallbacks for API variations
			if (!appointmentId && appt.appointmentID) appointmentId = appt.appointmentID;
			if (!appointmentId && appt.appointment_id) appointmentId = appt.appointment_id;
			if (!appointmentId && appointment.appointmentID) appointmentId = appointment.appointmentID;
			if (!appointmentId && appointment.appointment_id) appointmentId = appointment.appointment_id;
			if (!appointmentId && appt && appt.appointment && (appt.appointment.id || appt.appointment.appointmentId)) {
				appointmentId = appt.appointment.id || appt.appointment.appointmentId;
			}
			appointmentId = String(appointmentId || '').trim();
			if (!appointmentId) {
				closeCancelConfirmation();
				closePopup();
				if (typeof toastr !== 'undefined' && toastr && toastr.error) {
					toastr.error('', 'Unable to cancel appointment.');
				} else {
					alert('Unable to cancel appointment.');
				}
				return;
			}

			var dateTimeIso = appt.dateTime || appointment.dateTime || new Date().toISOString();
			var customerId =
				($('#customer_id').val && $('#customer_id').val()) ||
				(safeGetCookie('customerId') || safeGetCookie('customer_id')) ||
				(appointment.customer && appointment.customer.id) ||
				appointment.customerId ||
				'';
			var customerName =
				($('#customer_name').val && $('#customer_name').val()) ||
				(appointment.customer && appointment.customer.name) ||
				'';
			var mobile =
				($('#mobile').val && $('#mobile').val()) ||
				safeGetCookie('mobileNo') ||
				(appointment.customer && appointment.customer.contact && appointment.customer.contact[0] && appointment.customer.contact[0].number) ||
				'';

			var dealerId = dealer.id || ($('#new_dealer_id').val && $('#new_dealer_id').val()) || '';
			var dealerName = dealer.name || ($('#selected_dealer_name').val && $('#selected_dealer_name').val()) || '';
			var branchId =
				branch.id ||
				($('#branch_id').val && $('#branch_id').val()) ||
				($('#new_branch_id').val && $('#new_branch_id').val()) ||
				(safeGetCookie('branchId') || safeGetCookie('branch_id')) ||
				'1';
			var branchName = branch.name || ($('#branch_name').val && $('#branch_name').val()) || '';

			var payload = {
				appointment: {
					dateTime: dateTimeIso,
					status: 'Cancelled',
					communicationChannel: 'WEBSITE',
					Comments: "ONLINE APPOINTMENT",
					FollowupType: false,
					EmployeeId: 1
				},
				customer: {
					id: (typeof getNumeric === 'function') ? getNumeric(customerId, 0) : parseInt(customerId, 10) || 0,
					name: customerName || '',
					contact: mobile ? [{ type: 1, number: String(mobile), isPrimary: true }] : []
				},
				dealer: {
					id: (typeof getNumeric === 'function') ? getNumeric(dealerId, 0) : parseInt(dealerId, 10) || 0,
					name: dealerName || '',
					branch: {
						id: (typeof getNumeric === 'function') ? getNumeric(branchId, 0) : parseInt(branchId, 10) || 0,
						name: branchName || ''
					}
				}
			};
			const token = getCookie("jwt_token");
			try {
				var url = base_url + '/appointment/' + encodeURIComponent(appointmentId) + '/update';
				var resp = await $.ajax({
					url: url,
					method: 'PUT',
					type: 'PUT',
					headers: {
						Authorization: "Bearer " + (token || ""),
					},
					dataType: 'json',
					contentType: 'application/json',
					data: JSON.stringify(payload),
					crossDomain: true,
					xhrFields: { withCredentials: true },
					timeout: 30000,
				});

				var ok = !!(resp && resp.success === true && resp.data && Number(resp.data.statusCode) === 200);
				if (ok) {
					closeCancelConfirmation();
					closePopup();
					window.location.href = redirectUrl;
					return;
				}

				closeCancelConfirmation();
				closePopup();
				var msg = (resp && resp.data && resp.data.message) ? resp.data.message : 'Failed to cancel appointment.';
				if (typeof toastr !== 'undefined' && toastr && toastr.error) {
					toastr.error('', msg);
				} else {
					alert(msg);
				}
			} catch (err) {
				closeCancelConfirmation();
				closePopup();
				var msg2 = (err && err.responseJSON && err.responseJSON.data && err.responseJSON.data.message)
					? err.responseJSON.data.message
					: 'Failed to cancel appointment.';
				if (typeof toastr !== 'undefined' && toastr && toastr.error) {
					toastr.error('', msg2);
				} else {
					alert(msg2);
				}
			}
		});

	/*---------------------18-Nov-2025-OM_Dhananjay----------------------------------*/ 
	/* --------------------Show input select enter manually km------------------------*/

  

	const kmInput = document.getElementById("kmRangeInput");
	const kmInputBox = document.querySelector(".range_input-box");
	const kmButtons = document.querySelectorAll(".range_button button");
	// Global: stores selected preset max KM (e.g. "500 - 5000 KM" => 5000)
	window.selectedKmRangeMaxKm = window.selectedKmRangeMaxKm ?? null;
	kmInputBox.style.display = "none"; 
	kmButtons.forEach(button => {
		button.addEventListener("click", function () {
			const text = this.textContent.trim();
			// console.log("Clicked button:", text);

			if (text === "Enter Manually") {
				kmInputBox.style.display = "block";   
				kmInput.value = "";
				kmInput.focus();

			} else {
				kmInputBox.style.display = "none"; 
			}
			

			const displaySpan = document.querySelector("#selectDisplay span");
			displaySpan.textContent = (text === "Enter Manually")
				? "Enter manually"
				: text;

			// Trigger jobcard configuration fetch when a KM preset is selected
			if (text !== "Enter Manually") {
				const reading = extractKmFromText(text);
				// Persist selected preset KM in a global variable
				if (!isNaN(reading)) {
					window.selectedKmRangeMaxKm = reading;
				}

				// Same validation as manual entry: selected KM cannot be below last service KM
				// let lastKm = parseInt($('.km-notes').data('last-km'));
				 const lastKm = getLastKmValue();
				if (!isNaN(reading) && !isNaN(lastKm) && reading <= lastKm) {
					$("#kmErrorMsg")
						.text("You cannot enter KM below last service KM (" + lastKm + ").")
						.show();
					resetJobcardConfigurations();	
					return;
				}

				$("#kmErrorMsg").hide();
				if (!isNaN(reading) && reading > 0) {
					triggerJobcardConfigFetch(reading);
				}
			}

			// Re-evaluate submit button enable/disable whenever KM choice changes
			try { checkDisabled(); } catch (e) {}
		});
	});

	/*--------- Date-19-Nov 2025-OM_Dhananjay----------------------------------------*/
	/*---------Continue logic without select dealer list got with prevous dealer------*/

	$('#dealer-select-popup').on("click",function(e){

		// ==== new validation ====
		const prevId = ($("#new_dealer_id").val()).toString().trim();
		const hasChanged = !!(changedDealerData && changedDealerData.dealerId);
		console.log("Continue clicked. Validation check - prevId:", prevId, "hasChanged:", hasChanged);

		if (!hasChanged && !prevId) {
			// console.log('3623 pe phuncha');
			// no dealer selected from history or search
			toastr.error("", "Please select Dealer");
			e.preventDefault();
			e.stopImmediatePropagation();
			return;
		}
    // ==== end validation ====
		e.preventDefault();
		window.scrollTo({
			top: 0
		});
		$('#pincode-form').hide();
		$('.error-message').hide();
		$('.last-service-dealer').hide();
		$('.dealer_contact_info').hide();
		$('.service-info-section').hide();
		$('#dealer-select-popup').hide();

		console.log("Continue without selecting dealer");

	}) 

	/*----------------- 20-Nov-2025--OM_Dhananjay------------*/
	/*-----------------Logout functionality and change mobile number ----------------*/

	 $('.logout-btn').on("click",function(e){
		deleteCookie("mobileNo");
		location.reload();

	 });



	 /* ------------------ Edit  mobile number - Dhananjay ----------------*/
	 
	 $('.edit-number').on("click", function(e){	

		e.preventDefault();
		e.stopPropagation();
		deleteCookie("mobileNo");
		deleteCookie("customerNoRegister");
		localStorage.removeItem(BAS_LAST_VEHICLE_STORAGE_KEY);

		deleteCookie("vehicleId");
		deleteCookie("vehicleName");
		deleteCookie("vehicleImage");
		deleteCookie("vehicleRegNo");
		deleteCookie("vehicleFrameNo");
		deleteCookie("customerId"); 
		deleteCookie("jwt_token"); 

		location.reload();
	 });

	 /*----------- Back button functionality add new js -------------------*/

	  $('.back-btn, .bike-edit, .dealer-edit-info').on("click", function(e){
		$('.booking-summary-heading, .bike-detail-content-section, #booking_summary, .pdd_image_box').hide();
		$('.dealer_contact_info, .service-info-section, .last-service-dealer, #single-bike-data, #bike-detail-slider, #add-new-bike, #pincode-form, .bike_chasis_no').show();
		
		$('.dealer_block-outer').removeClass('booking-summary');
		$('.btn-row, #dealer-select-popup,#add-new-dealer-popup').show();
		$('.previous_dealer_details-head').hide();
	  })


	  /*---------- Add validation  last km input ----------------*/

	  	function resetJobcardConfigurations() {
			// Clear dropdown options
			updateJobTypeAndConvenience([], []);

			// Disable dropdowns
			setJobcardConfigDropdownsDisabled(true);

			// Clear stored odometer
			window._currentOdometer = null;
		}
		function getLastKmValue() {
			const kmValue = $('.km-notes').attr('data-last-km');
			return !isNaN(kmValue) ? parseInt(kmValue, 10) : null;
		}


	  	$("#kmRangeInput").on("input", function () {
			 const lastKm = getLastKmValue();
			// let lastKm = parseInt($('.km-notes').data('last-km')); 
			let enteredKm = parseInt($(this).val());

			if (!isNaN(enteredKm) && enteredKm <= lastKm) {

				$("#kmErrorMsg")
					.text("You cannot enter KM below last service KM (" + lastKm + ").")
					.show();

				resetJobcardConfigurations();   

			} else if (isNaN(enteredKm) || enteredKm <= 0) {

				$("#kmErrorMsg").hide();
				resetJobcardConfigurations();   

			} else {

				$("#kmErrorMsg").hide();
				triggerJobcardConfigFetch(enteredKm);
			}

			try { checkDisabled(); } catch (e) {}
		});

	/*-------------------19-Nov-2025- Rambeer-------------------------------------*/
	/* ----------------- AMC, RSA plans popup-------------------------------------*/

	const openBtn = $("#amc-rsa-plans");
	const popup = $("#amc-rsa-palns-popup");
	const overlay = $("#amc-rsa-palnsOverlay");
	const closeBtn = $("#closeplansPopup");
	const interest = $("#intrested");
	const skip = $("#skip-intrest");
	const nudgetSelectedResult = $("#nudget-result");
	openBtn.on("click", function () {
		popup.addClass("show");
		overlay.show();
	});

	closeBtn.on("click", function () {
		popup.removeClass("show");
		overlay.hide();
	});

	overlay.on("click", function () {
		popup.removeClass("show");
		overlay.hide();
	});

	interest.on("click", function(){
		popup.removeClass("show");
		overlay.hide();
		nudgetSelectedResult.show(); 
	})

	skip.on("click", function(){
		// console.log("skip clicked");
		popup.removeClass("show");
		overlay.hide();
		nudgetSelectedResult.hide();
		// Remove  selected value
		$("#amc_rsa_opted").val("");
	})

   /*---------------- 21-Nov-2025-Prachi---------------------*/
   /*-----------------Add class in popup when plan select ---------------------*/
   	document.querySelectorAll('.plan-radio').forEach(radio => {
		radio.addEventListener('change', () => {
			document.querySelectorAll('.plan-card').forEach(card => card.classList.remove('plan-selected'));
			radio.closest('.plan-card').classList.add('plan-selected');
		});
	});


	
 
	// Submit button click handler
	$(".submit-plan-btn").on("click", async function (e) {
		e.preventDefault();
		if (!checkFields()) return false;
		await submitPlanAndRedirect();
		return false; 
	});

	 //Open popup add new bike 
	$("#new-bike_add,#add-new-bike").on("click", function (e) {
		e.preventDefault(); 
		$('#add_new_bike_warper').show();
  		$('#add-new-bike-popup').show();
		$('body').addClass('overflow-hidden');
	});

	$('#new_bike_add_close').on("click", function (){
		$('#add-new-bike-popup').hide();
		$("#regis_chasis_number_tnc").prop("checked", false);
		$("#chasis-number").val("");
		$('body').removeClass('overflow-hidden');
		$("#add-new-vechicle").prop("disabled", true);
	})

	$(document).on("click", "#create-an-appointment", function () {
		createAppointment();
		if ($(".shopify-section-header-sticky").length > 0) {
			$("html, body").animate({ scrollTop: 0 }, "fast");
		}
	});
	let flag1 = false; // Job Type
	let flag3 = false; // Convenience Mode
	let flag4 = false; // Date & Time

	// Initialize button as disabled on page load
	$(".submit-plan-btn").prop("disabled", true);

	// Ensure disabled click catcher exists/updated
	function showMissingToast() {
		const msg = 'Some required fields are missing';
		if (typeof toastr !== 'undefined' && toastr && toastr.error) {
			toastr.error('', msg);
		} else {
			try { alert(msg); } catch (e) {}
		}
	}

	function updateDisabledCatcher() {
		$('.submit-plan-btn').each(function () {
			const $btn = $(this);
			let $catch = $btn.siblings('.disabled-catcher');
			if ($btn.prop('disabled')) {
				if ($catch.length === 0) {
					$catch = $('<div class="disabled-catcher" aria-hidden="true"></div>');
					$btn.after($catch);
					const $parent = $btn.parent();
					if ($parent.css('position') === 'static') $parent.css('position', 'relative');
					$catch.css({
						position: 'absolute',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						cursor: 'not-allowed',
						zIndex: 9999,
						background: 'transparent'
					});
					$catch.on('click', function (e) {
						e.preventDefault();
						e.stopPropagation();
						showMissingToast();
					});
				}
				$catch.show();
			} else {
				if ($catch.length) $catch.hide();
			}
		});
	}

	$(document).on("change", ".input-container-Service", function () {
		$("#serviceError").html("");
		let periodicService = $("#periodic-maintenance-services").val();

		if (periodicService !== "Select an Option") {
			flag1 = true;
			checkDisabled();
		} else {
			flag1 = false;
			checkDisabled();
		}
	});

	$(document).on("change", ".input-container-convenience", function () {
		let convenience = $("#convenience").val();
		$("#convenienceError").html("");

		if (convenience !== "Select an Option") {
			flag3 = true;
			checkDisabled();
		} else {
			flag3 = false;
			checkDisabled();
		}
	});

	$(document).on("input", "#date_form_id", function () {
		let datefield = $("#date_form_id").val();
		$("#dateError").html("");
		if (datefield && datefield.trim() !== "") {
			flag4 = true;
		} else {
			flag4 = false;
		}
		checkDisabled();
	});

	$(document).on("change", "#dateRange", function () {
		let dateRange = $("#dateRange").val();
		if (dateRange && dateRange.trim() !== "") {
			flag4 = true;
		} else {
			flag4 = false;
		}
		checkDisabled();
	});

	function checkDisabled() {
		// console.log("checkDisabled called - Flags:", {flag1, flag3, flag4});
		// console.log("Field values:", {
		// 	service: $("#periodic-maintenance-services").val(),
		// 	convenience: $("#convenience").val(),
		// 	dateRange: $("#dateRange").val(),
		// 	dateTime: $("#date_form_id").val(),
		// 	kmManualVisible: (document.querySelector('.range_input-box') ? getComputedStyle(document.querySelector('.range_input-box')).display : 'none')
		// });

		// If manual KM input is visible, require a valid km value
		let manualOk = true;
		const kmBox = document.querySelector('.range_input-box');
		if (kmBox && getComputedStyle(kmBox).display !== 'none') {
			const v = String($("#kmRangeInput").val() || '').trim();
			const entered = parseInt(v, 10);
			let lastKm = parseInt($('.km-notes').data('last-km'));
			if (!v || v === '' || isNaN(entered) || entered <= 0) {
				manualOk = false;
			} else if (!isNaN(lastKm) && entered < lastKm) {
				manualOk = false;
			}
		}

		if (flag1 && flag3 && flag4 && manualOk) {
			$(".submit-plan-btn").prop("disabled", false);
			$(".vpb-toggle").removeClass("disabled");
			// console.log("Button ENABLED");
		} else {
			$(".submit-plan-btn").prop("disabled", true);
			$(".vpb-toggle").addClass("disabled");
			// console.log("Button DISABLED - Missing:", {flag1, flag3, flag4, manualOk});
		}

		// Update click-catcher overlay for disabled buttons
		try { updateDisabledCatcher(); } catch (e) {}
	}

	// Attach click handler to the submit button only once
	$(document).on("click", ".submit-plan-btn", function () {
		if (!checkFields()) {
			return false;
		}

	});

	// Helper: extract numeric odometer from button text like "500 KM", "0 - 500 KM"
	function extractKmFromText(text) {
		const nums = (text.match(/\d+/g) || []).map(n => parseInt(n));
		if (nums.length === 0) return NaN;
		return Math.max.apply(null, nums);
	}

	// Update dropdowns from jobcard configuration response
	function updateJobTypeAndConvenience(jobTypes = [], convenienceModes = []) {
		const $jobTypeSelect = $("#periodic-maintenance-services");
		const $convenienceSelect = $("#convenience");

		if ($jobTypeSelect.length) {
			let jobHtml = '<option value="Select an Option">Select an Option</option>';
			jobTypes.forEach(j => {
				const title = j.title || j.description || j.name || String(j.id || "");
				const val = (j.id != null ? j.id : title);
				jobHtml += `<option value="${val}">${ toTitleCase(title)}</option>`;
			});
			$jobTypeSelect.html(jobHtml);
			$jobTypeSelect.trigger('change');
		}

		if ($convenienceSelect.length) {
			let convHtml = '<option value="Select an Option">Select an Option</option>';
			convenienceModes.forEach(c => {
				const title = c.title || c.description || c.name || String(c.id || "");
				if (title === "Road side assistance") {
					return; // skip this item
				}
				const val = (c.id != null ? c.id : title);
				convHtml += `<option value="${val}">${toTitleCase(title)}</option>`;
			});
			$convenienceSelect.html(convHtml);
			$convenienceSelect.trigger('change');
		}
	}

	function setJobcardConfigDropdownsDisabled(disabled) {
		const $jobTypeSelect = $("#periodic-maintenance-services");
		const $convenienceSelect = $("#convenience");
		$jobTypeSelect.prop("disabled", !!disabled);
		$convenienceSelect.prop("disabled", !!disabled);
	}

	function setJobcardConfigLoading(isLoading) {
		const $section = $("#jobcard-config-section");
		if ($section.length) {
			$section.toggleClass("jobcard-config--loading", !!isLoading);
		}
	}

	// Disabled by default; enabled only after jobcard API success.
	$(function () {
		setJobcardConfigDropdownsDisabled(true);
		setJobcardConfigLoading(false);
	});

	// Fire GET to fetch jobcard configurations
	function fetchJobcardConfigurations(frameNo, odometerReading) {

		const token = getCookie("jwt_token");
		const frameNon = frameNo //'MD626BG46E1F97535';
		const odo = odometerReading
		if (!frameNo || isNaN(odo)) return Promise.resolve();

		const url = `${base_url}/jobcard/configurations/fetch/${encodeURIComponent(frameNon)}?odometerReading=${encodeURIComponent(odo)}`;
		return new Promise((resolve) => {
			setJobcardConfigDropdownsDisabled(true);
			setJobcardConfigLoading(true);
			$.ajax({
				url,
				method: "GET",
				xhrFields: {
   					 withCredentials: true
				},
				dataType: "json",
				crossDomain: true,
				success: function (resp) {
					try {
						const container = resp?.data || resp || {};
						updateJobTypeAndConvenience(container.jobTypes || [], container.convenienceModes || []);
					} catch (e) {}
					setJobcardConfigDropdownsDisabled(false);
					resolve();
				},
				error: function () {
					resolve();
				},
				complete: function () {
					setJobcardConfigLoading(false);
				}
			});
		});
	}

	// Bridge to compute inputs and call fetch
	function triggerJobcardConfigFetch(odometerReading) {
		const frameNo = $("#vehicle_chasis_no").val() || "";
		const odo = parseInt(odometerReading, 10);
		if (!isNaN(odo)) {
			window._currentOdometer = odo;
		}
		fetchJobcardConfigurations(frameNo, odo);
	}

	// Parse value of #date_form_id (e.g., "12-11-2025 & 16:30") to ISO string
	function parseAppointmentISO() {
		const v = $("#date_form_id").val() || "";
		// console.log("Parsing appointment datetime from input:", v);
		if (!v.includes("&")) return null;
		try {
			const [datePart, timePartRaw] = v.split("&").map(s => s.trim());
			const [dd, mm, yyyy] = datePart.split("-").map(x => parseInt(x));
			const [hh, minu] = timePartRaw.split(":").map(x => parseInt(x));
			const d = new Date(yyyy, (mm - 1), dd, hh, minu, 0);
			if (isNaN(d.getTime())) return null;
			return d.toISOString();
		} catch (_) { return null; }
	}


	function parseAppointmentISO_updated() {
		const v = $("#date_form_id").val() || "";

		// console.log("Parsing appointment datetime from input:", v);
		if (!v.includes("&")) return null;

		try {
			const [datePart, timePartRaw] = v.split("&").map(s => s.trim());
			const [dd, mm, yyyy] = datePart.split("-");

			// Directly construct string (NO Date object)
			const formatted = `${yyyy}-${mm}-${dd}T${timePartRaw}:00.000Z`;

			return formatted;
		} catch (e) {
			// console.log("Date parse error:", e);
			return null;
		}
	}


	function getSelectedText($sel) {
		const opt = $sel.find('option:selected');
		return opt.length ? (opt.text() || '').trim() : '';
	}

	function getNumeric(val, fallback = 0) {
		const n = parseInt(val);
		return isNaN(n) ? fallback : n;
	}

	// ------------------ Slots by selected Date Range (API-driven) ------------------
	// Requirements:
	// - Show ONLY dates in selected range on top
	// - Keep existing slot HTML structure (all slots stay in DOM)
	// - Enable only API-available slots; keep rest disabled (grey + non-clickable)
	// - API shape: resp.success === true and daily list at resp.data[0].dailySlotResponse

	function _slotApiRoot() {
		try {
			return String(base_url || "").replace(/\/book_a_service\/?$/, "");
		} catch (_) {
			return base_url;
		}
	}

	function _pad2(n) {
		return String(n).padStart(2, "0");
	}

	function _isoDateOnly(d) {
		return `${d.getFullYear()}-${_pad2(d.getMonth() + 1)}-${_pad2(d.getDate())}`;
	}

	function _parseDateRangeInput(val) {
		// flatpickr default: "YYYY-MM-DD to YYYY-MM-DD"
		const v = String(val || "").trim();
		if (!v) return null;
		const parts = v.split(" to ");
		// If user selected only a single date, treat it as from==to
		// (flatpickr range mode can yield a single date until the second is picked).
		if (parts.length === 1) {
			parts.push(parts[0]);
		}
		if (parts.length !== 2) return null;

		function parseOne(s) {
			const str = String(s || "").trim();
			// Prefer strict YYYY-MM-DD parsing in local time to avoid UTC shifts
			const m = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
			if (m) {
				const y = parseInt(m[1], 10);
				const mo = parseInt(m[2], 10);
				const da = parseInt(m[3], 10);
				return new Date(y, mo - 1, da);
			}
			const d = new Date(str);
			return isNaN(d.getTime()) ? null : d;
		}

		let from = parseOne(parts[0]);
		let to = parseOne(parts[1]);
		if (!from || !to) return null;

		// Normalize if user types reversed range
		if (from.getTime() > to.getTime()) {
			const tmp = from;
			from = to;
			to = tmp;
		}

		return { from, to };
	}

	function _eachDay(from, to) {
		const out = [];
		const start = new Date(from.getFullYear(), from.getMonth(), from.getDate());
		const end = new Date(to.getFullYear(), to.getMonth(), to.getDate());
		for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
			out.push(new Date(d));
		}
		return out;
	}

	function _tabLabel(d) {
		return d.toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" });
	}

	function _bookingLabel(d) {
		// matches existing slot click parsing ("Dec 22")
		return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
	}

	function _headerLabel(d) {
		const day = d.toLocaleDateString("en-US", { day: "2-digit" });
		const mon = d.toLocaleDateString("en-US", { month: "short" });
		return `${parseInt(day, 10)} ${mon} Available Slot`;
	}

	function _timeRangeToValue(timeRange) {
		// "10:00 AM - 10:30 AM" => "1000"
		if (!timeRange) return "";
		const start = String(timeRange).split("-")[0].trim();
		const m = start.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
		if (!m) return "";
		let hh = parseInt(m[1], 10);
		const mm = parseInt(m[2], 10);
		const ap = String(m[3] || "").toUpperCase();
		if (ap === "PM" && hh !== 12) hh += 12;
		if (ap === "AM" && hh === 12) hh = 0;
		return `${_pad2(hh)}${_pad2(mm)}`;
	}

	function _normalizeDailyFromResp(resp) {
		if (!resp) return [];
		// Support multiple API shapes (new + legacy) without breaking other flows:
		// - New:   resp.data.dailySlotResponse
		// - Legacy: resp.data[0].dailySlotResponse
		// - Other:  resp.dailySlotResponse / resp.data (already the list)
		const daily =
			resp?.data?.dailySlotResponse ||
			resp?.data?.[0]?.dailySlotResponse ||
			resp?.dailySlotResponse ||
			(Array.isArray(resp?.data) ? resp.data : null);
		if (!Array.isArray(daily)) return [];
		return daily
			.map((d) => {
				const dateObj = new Date(d.date);
				const dateKey = isNaN(dateObj.getTime()) ? "" : _isoDateOnly(dateObj);
				return {
					dateKey,
					dateObj,
					isSlotAvailable: !!d.isSlotAvailable,
					slots: Array.isArray(d.slots) ? d.slots : [],
				};
			})
			.filter((x) => x.dateKey);
	}

	function fetchSlotsByRange(fromDateStr, toDateStr) {
		const apiRoot = _slotApiRoot();
		const urls = [
			`${base_url}/fetch-slot`,
		];

		const token = getCookie("jwt_token");

		const dealerId = getNumeric($("#new_dealer_id").val(), 0);
		const branchId = getNumeric($("#branch_id").val(), 1);
		const payload = { dealerId, branchId, fromDate: fromDateStr, toDate: fromDateStr };
		const url = `${base_url}/fetch-slot`;

		// console.log('fetch toke', token);
		// console.log('dealerId', dealerId);

		// console.log("FROM:", fromDateStr);
		//  console.log("TO:", toDateStr);

		function request(idx) {
			if (idx >= urls.length) return Promise.reject(new Error("Slot API failed"));
			return new Promise((resolve, reject) => {
				$.ajax({
					url: url,
					method: "POST",
					xhrFields: {
    					withCredentials: true
					},
					dataType: "json",
					contentType: "application/json",
					data: JSON.stringify(payload),
					//headers: typeof token !== "undefined" && token ? { Authorization: "Bearer " + token } : {},
					crossDomain: true,
					success: resolve,
					error: function () {
						request(idx + 1).then(resolve).catch(reject);
					},
				});
			});
		}
		return request(0);
	}

	function _disableAllSlots() {
		$(".slots").addClass("disabled time-btn-slot-disable").prop("disabled", true);
		$(".time_slot_js").removeClass("active");
	}

	function _resetSlotsPopupUI() {
		try {
			$("#dates_container").html("");
			$("#slot_id").val("");
			window._slotDailyMap = {};
			window._selectedSlotDateParts = null;
			_disableAllSlots();
		} catch (_) {}
	}

	function _applySlotsForDateKey(dateKey) {
		const map = window._slotDailyMap || {};
		const day = map[String(dateKey || "")];
		const d = day?.dateObj ? day.dateObj : new Date(String(dateKey) + "T00:00:00");

		$("#date_modal_selected").text(_headerLabel(d));
		$("#booking_date").val(_bookingLabel(d));
		window._selectedSlotDateParts = { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate() };

		_disableAllSlots();
		if (!day || day.isSlotAvailable !== true) return;

		(day.slots || []).forEach((slot) => {
			const available = parseInt(slot.available, 10);
			if (!isNaN(available) && available <= 0) return;
			const val = _timeRangeToValue(slot.time);
			if (!val) return;
			$(".slots." + val)
				.removeClass("disabled time-btn-slot-disable")
				.prop("disabled", false);
		});

		// keep past times disabled for today
		const now = new Date();
		if (_isoDateOnly(now) === String(dateKey)) {
			const currentTime = getCurrentTime();
			$(".slots").each(function () {
				const v = parseInt($(this).find(".time_slot_js").attr("value"), 10);
				if (!isNaN(v) && v < currentTime) {
					$(this).addClass("disabled time-btn-slot-disable").prop("disabled", true);
				}
			});
		}
	}

	function _buildRangeTabs(from, to, dailyList) {
		const days = _eachDay(from, to);
		const dailyMap = {};
		(dailyList || []).forEach((d) => {
			dailyMap[d.dateKey] = d;
		});
		window._slotDailyMap = dailyMap;

		const $container = $("#dates_container");
		$container.html("");

		days.forEach((d) => {
			const key = _isoDateOnly(d);
			const daily = dailyMap[key];
			// Show the per-slot availability coming from API (e.g., "available": 8)
			// If multiple slots exist for the day, show the maximum availability among them.
			const maxAvail = daily && daily.isSlotAvailable
				? (daily.slots || []).reduce((mx, s) => {
					const a = parseInt(s.available, 10);
					if (isNaN(a)) return mx;
					return Math.max(mx, a);
				}, 0)
				: 0;
			const label = _tabLabel(d);
			$container.append(`
				<div class="date_slot" data-date-key="${key}" data-date="${label}">
					<h3 class="date">${label}</h3>
				</div>
			`);
		});

		const firstKey = days.length ? _isoDateOnly(days[0]) : "";
		if (firstKey) {
			$container.find(`.date_slot[data-date-key="${firstKey}"]`).addClass("active");
			_applySlotsForDateKey(firstKey);
		}
	}

	function loadSlotsPopupFromSelectedRange() {
		// Bump request sequence so older responses are ignored
		window._slotRangeReqSeq = (window._slotRangeReqSeq || 0) + 1;
		const reqSeq = window._slotRangeReqSeq;

		// Abort any previous in-flight slot request (prevents stale render)
		try {
			if (window._slotRangeXhr && window._slotRangeXhr.readyState !== 4) {
				window._slotRangeXhr.abort();
			}
		} catch (_) {}

		// Always clear old UI when user changes range
		_resetSlotsPopupUI();

		const parsed = _parseDateRangeInput($("#dateRange").val());
		if (!parsed) {
			toastr.error("", "Please select a date range");
			return;
		}
		// Backend validation (observed): fromDate must not be greater than "currentDate".
		// Users can select future ranges, so clamp API fromDate to today while still
		// rendering ONLY the user-selected range in the popup.
		const today = new Date();
		const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
		const fromStart = new Date(parsed.from.getFullYear(), parsed.from.getMonth(), parsed.from.getDate());
		
		//comment on 15 octuber 
		// const fromDateStr = _isoDateOnly(fromStart > todayStart ? todayStart : fromStart);
		// const toDateStr = _isoDateOnly(new Date(parsed.to.getFullYear(), parsed.to.getMonth(), parsed.to.getDate()));

		const fromDateStr = _isoDateOnly(new Date(parsed.from.getFullYear(), parsed.from.getMonth(), parsed.from.getDate()));
		const toDateStr   = _isoDateOnly(new Date(parsed.to.getFullYear(), parsed.to.getMonth(), parsed.to.getDate()));

		const p = fetchSlotsByRange(fromDateStr, toDateStr);
		// Keep reference for aborting
		window._slotRangeXhr = p;

		Promise.resolve(p)
			.then((resp) => {
				// Ignore out-of-order responses
				if (reqSeq !== window._slotRangeReqSeq) return;
				// New API may not return { success: true }; accept if it contains dailySlotResponse
				const hasDaily = !!(resp?.dailySlotResponse || resp?.data?.dailySlotResponse || resp?.data?.[0]?.dailySlotResponse);
				if (!resp || (resp.success !== true && !hasDaily)) {
					throw new Error(resp?.message || "Unable to fetch slots");
				}
				const dailyList = _normalizeDailyFromResp(resp);
				_buildRangeTabs(parsed.from, parsed.to, dailyList);

				// If user selected a single date, open the slot popup automatically
				// (from == to) after API data is ready.
				try {
					const sameDay = _isoDateOnly(new Date(parsed.from)) === _isoDateOnly(new Date(parsed.to));
					if (sameDay) {
						$("#date_time_modal").show();
						$("body").addClass("overflow-hidden");
					}
				} catch (_) {}
			})
			.catch((err) => {
				// Ignore out-of-order failures
				if (reqSeq !== window._slotRangeReqSeq) return;
				_resetSlotsPopupUI();
				toastr.error("", (err && err.message) ? err.message : "Unable to fetch slots");
			});
	}

	// Trigger slot API on date range selection
	$(document).on("change", "#dateRange", function () {
		loadSlotsPopupFromSelectedRange();
	});




	function hydrateThankYouPageFromSession() {
		try {
			// Only run if Thank You DOM exists
			if (!document.getElementById('jobbcard_srNo')) return;

			const raw = sessionStorage.getItem('appointmentData');
			if (!raw) {
				// If someone lands directly on thank-you, bounce back to book-a-service
				try {
					window.location.href = window.location.origin + '/';
				} catch (_) {}
				return;
			}

			const data = JSON.parse(raw || '{}');
			if (!data.appointmentId) return;

			// Serial No.
			document.getElementById('jobbcard_srNo').innerText = String(data.appointmentId);

			// Selected Dealer
			if (document.getElementById('jobbcard_dealer') && data.dealerName) {
				document.getElementById('jobbcard_dealer').innerText = String(data.dealerName);
			}

			// Selected Date & Time
			if (document.getElementById('time_slot_in_format') && data.selectedDateTime) {
				document.getElementById('time_slot_in_format').innerText = String(data.selectedDateTime);
			}

			// Mobile
			if (document.getElementById('jobbcard_dealerContactno') && data.mobile) {
				const m = String(data.mobile);
				document.getElementById('jobbcard_dealerContactno').innerText = m.startsWith('+') ? m : `+91${m}`;
			}

			// Bike image + registration + model name (no IDs in markup; use selectors)
			if (data.vehicleImage) {
				const img = document.querySelector('#customer_bike_image img');
				if (img) img.setAttribute('src', String(data.vehicleImage));
			}
			if (data.registrationNo) {
				const regEl = document.querySelector('.thankyou-bike-details .bike-details-content h3');
				if (regEl) regEl.textContent = String(data.registrationNo);
			}
			if (data.vehicleName) {
				const nameEl = document.querySelector('.thankyou-bike-details .bike-details-content p');
				if (nameEl) nameEl.textContent = String(data.vehicleName);
			}

			// Optional: hide loader / show wrapper if present
			const loader = document.getElementById('loaderr');
			if (loader) loader.style.display = 'none';
			const wrapper = document.getElementById('thank-you-wrapper');
			if (wrapper) wrapper.style.display = 'block';

			// Clear so refresh doesn’t re-apply stale data
			sessionStorage.removeItem('appointmentData');
		} catch (e) {
			// ignore
		}
	}


	// Format Date and Time to "12 Nov 2025, 4:30 PM" format for thank-you page display
	function formatDateTimeForThankYou(dateTimeStr) {
		try {
			if (!dateTimeStr) return "";
			// Example input: "02/23/2026 02:00:00"
			const [datePart, timePart] = dateTimeStr.split(" ");
			let [hour, minute] = timePart.split(":").map(Number);

			const ampm = hour >= 12 ? "PM" : "AM";
			hour = hour % 12 || 12; // 0 -> 12

			return `${datePart} ${hour}:${String(minute).padStart(2, "0")} ${ampm}`;
		} catch (_) {
			return "";
		}
	}

	/**------ Redirect to success page after creating appointment api called   ----------- */
	async function submitPlanAndRedirect() {
		$("#loaderr").css("display", "flex");
		const thankYouUrl = "https://service.tvsmotor.com/pages/thank-you";
		const bookingFailedUrl = "https://service.tvsmotor.com/pages/booking-failed";
		const dealerId = $("#new_dealer_id").val() || "";
		const dealerName = $("#selected_dealer_name").val() || selectedDealerName || "";
		// appointment/create expects a valid branch id (observed: 1). If UI doesn't expose it,
		// fall back safely instead of sending 0.
		const branchId =
			$("#branch_id").val() ||
			$("#branchId").val() ||
			$("#new_branch_id").val() ||
			(getCookie && (getCookie("branchId") || getCookie("branch_id"))) ||
			"1";
		const branchName =
			$("#branch_name").val() ||
			$("#branchName").val() ||
			"";

	    let communicationChannel;
		if (urlChanel) {
			communicationChannel = urlChanel;
		} else {
			communicationChannel = "WEBSITE";
		}
		const vehicleId = $("#vehicle_id").val() || "";
		const vehicleName = $("#selected_vehicle_name").val() || "";
		const vehicleImage = $("#selected_vehicle_img").val() || "";
		const registrationNo = $("#vehicle_registration_no").val() || "";
		// Use actual customer id from login flow (hidden input + cookies)
		const customerId = $("#customer_id").val()
		const customerName = $("#customer_name").val() || "";
		const mobile = $("#mobile").val() || (getCookie && getCookie('mobileNo')) || "";

		const jobTypeSel = $("#periodic-maintenance-services");
		const jobTypeId = getNumeric(jobTypeSel.val(), 0);
		const jobTypeDesc = getSelectedText(jobTypeSel);

		const serviceModeSel = $("#periodic-services-mode");
		const serviceModeId = serviceModeSel.length ? getNumeric(serviceModeSel.val(), 0) : 1;
		const serviceModeDesc = serviceModeSel.length ? getSelectedText(serviceModeSel) : "Walk-in";

		const convSel = $("#convenience");
		const convId = getNumeric(convSel.val(), 0);
		const convDesc = getSelectedText(convSel);

		const odometer = window._currentOdometer || parseInt($("#kmRangeInput").val()) || null;
		const isoDateTime =  parseAppointmentISO_updated(); //parseAppointmentISO();
		const remarks = $("#remarks").val() || "";
		const amc_rsa_opted = $("#amc_rsa_opted").val() || "";
		// Non-zero referenceNo improves compatibility with backends that validate it.
		// const referenceNo = Math.floor(Date.now() / 1000);

		const payload = {
			dealer: {
				id: getNumeric(dealerId, 0),
				name: dealerName,
				branch: { id: getNumeric(branchId, 0)|| 1, name: branchName }
			},
			vehicle: { id: getNumeric(vehicleId, 0) },
			customer: {
				id: getNumeric(customerId, 0),
				name: customerName,
				contact: [{ type: 1, number: String(mobile), isPrimary: true }]
			},
			appointment: {
				dateTime:   isoDateTime,
				serviceType: { id: jobTypeId, description: jobTypeDesc },
				kilometer: getNumeric(odometer, 0),
				serviceMode: { id: serviceModeId, description: serviceModeDesc },
				convenienceMode: { id: convId, description: convDesc },
				// referenceNo: referenceNo,
				customerRemarks: remarks,
				communicationChannel: communicationChannel,//"WEBSITE",
				communicationMode: "ONLINE",
				customerRequests: [
					{
						"requestType": "AMC",
						"subType": [
							{
								"name": amc_rsa_opted
							}
							
						]
					}
				]
			}
		}; 

		// Call new appointment API, redirect ONLY on success
		try {
			const url = `${base_url}/appointment/create`;
			const token = getCookie("jwt_token");
			const resp = await $.ajax({
				url: url,
				method: 'POST',
				xhrFields: {
    				withCredentials: true
				},
				dataType: 'json',
				contentType: 'application/json',
				data: JSON.stringify(payload),
				crossDomain: true,
			});


	    	const isOk = !!(resp && resp.success === true && resp.data && resp.data.appointmentId);
			///const isOk=false 
			if (!isOk) {
				toastr.error('', 'Failed to create appointment. Please try again.');
				window.location.href = bookingFailedUrl;
				return;
			} 

			const container = resp.data; // safe due to isOk


			// console.log("API response for appointment creation:", resp.data);
	
			const appointmentId = container.appointmentId;

			const rawAppointmentDateTime = container.appointmentDateTime || "";
			const formattedAppointmentDateTime = formatAppointmentDateTime(rawAppointmentDateTime);

			// console.log("Created appointment ID:", appointmentId);
			// console.log("Appointment DateTime (raw):", rawAppointmentDateTime);
			// console.log("Appointment DateTime (formatted):", formattedAppointmentDateTime);

			// const appointmentDateTime = container.appointmentDateTime || null;
			// console.log("Created appointment ID:", appointmentId);
			// Store everything for the thank-you page to read (same pattern as old addJobCard)
			try {
				sessionStorage.setItem('appointmentData', JSON.stringify({
					appointmentId: appointmentId,
					appointmentDateTime: formattedAppointmentDateTime || "",
					dealerName: dealerName || "",
					selectedDateTime: $("#date_form_id").val() || "",
					mobile: String(mobile || ""),
					vehicleName: vehicleName || "",
					vehicleImage: vehicleImage || "",
					registrationNo: registrationNo || "",
					payload: payload,
					chanel: communicationChannel || "",
					url:connectHomeUrl
				}));
			} catch (_) {
				$("#loaderr").css("display", "none");
			}

			// If page has a placeholder for serial number, reflect it before redirecting (optional visual feedback)
			if ($('#jobbcard_srNo').length) {
				$('#jobbcard_srNo').text(String(appointmentId));
			}

			window.location.href = thankYouUrl;
		} catch (e) {
			$("#loaderr").css("display", "none");
			toastr.error('', 'Unable to create appointment. Please check your network and try again.');
			setTimeout(function () {
				window.location.href = bookingFailedUrl;
			}, 2000);
			return;
		}
	}

	// If we're on Thank You page, populate it immediately
	document.addEventListener('DOMContentLoaded', function () {
		hydrateThankYouPageFromSession();
	});

	// Function to check all fields for validation
	function checkFields() {
		let periodicService = $("#periodic-maintenance-services").val();
		let convenience = $("#convenience").val();
		let dateRange = $("#dateRange").val();
		let datefield = $("#date_form_id").val();
		let isValid = true; // Assume all fields are valid initially

		// Validate each field and show error if needed
		if (periodicService === "Select an Option") {
			$("#serviceError").html("Please fill the Service Type");
			isValid = false;
		}

		if (convenience === "Select an Option") {
			$("#convenienceError").html("Please fill the Convenience Mode");
			isValid = false;
		}

		// if (!dateRange || dateRange.trim() === "") {
		// 	$("#dateError").html("Please select a date range");
		// 	isValid = false;
		// }

		if (!datefield || datefield.trim() === "") {
			$("#dateSlotError").html("Please select a time slot");
			isValid = false;
		}

		// If manual KM input box is visible, ensure value present and valid
		const kmBox = document.querySelector('.range_input-box');
		if (kmBox && getComputedStyle(kmBox).display !== 'none') {
			const v = String($("#kmRangeInput").val() || '').trim();
			const entered = parseInt(v, 10);
			let lastKm = parseInt($('.km-notes').data('last-km'));
			if (!v || v === '' || isNaN(entered) || entered <= 0) {
				$("#kmErrorMsg").text("Please enter kilometre").show();
				isValid = false;
			} else if (!isNaN(lastKm) && entered < lastKm) {
				$("#kmErrorMsg").text("You cannot enter KM below last service KM (" + lastKm + ").").show();
				isValid = false;
			} else {
				$("#kmErrorMsg").hide();
			}

		}
		return isValid;
	}

	/* -------Create and appointment API Call -----------------*/


	// custom select box 
	const selectDisplay = document.getElementById("selectDisplay");
    // const selectOptions = document.getElementById("selectOptions");
    // const buttons = selectOptions.querySelectorAll("button");
    // selectDisplay.addEventListener("click", () => {
    //   const isOpen = selectOptions.classList.toggle("show");
    //   selectDisplay.classList.toggle("open", isOpen);
    // });

    // buttons.forEach((btn) => {
    //   btn.addEventListener("click", (e) => {
    //     e.preventDefault(); // ✅ prevent refresh
    //     buttons.forEach(b => b.classList.remove("active"));
    //     btn.classList.add("active");
    //     selectDisplay.querySelector("span").innerText = btn.dataset.value;
    //     selectOptions.classList.remove("show");
    //   });
    // });

    // window.addEventListener("click", (e) => {
    //   if (!e.target.closest(".custom-select-box")) {
    //     selectOptions.classList.remove("show");
    //   }
    // });

// All plan cards
const planCards = document.querySelectorAll(".plan-card");

// Nudget result div
const nudgetResult = document.getElementById("nudget-result");

planCards.forEach(card => {
    card.addEventListener("click", () => {

        // 1. Auto-select radio
        const radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        // 2. Time value
        const timeValue = radio.dataset.time || radio.value || "N/A";

		// Set hidden input value
		$("#amc_rsa_opted").val(timeValue);

        // 3. Title value
        const titleEl = card.querySelector(".plan-title, h3, h4");
        const titleText = titleEl ? titleEl.innerText.trim() : "";

        // 4. Price value (smart detection)
        const priceEl = card.querySelector(".price, .plan-price, h5, p.price, span.price");
        const priceText = priceEl ? priceEl.innerText.trim() : "Price not found";

        // 5. Show in #nudget-result
        nudgetResult.innerHTML = `
           <div class="nudget-result-box">
                <h2><strong>${timeValue}</strong></h2>
                <h4>Price: <strong>${priceText}</strong></h4>
            </div>
        `;
    });
});

document.querySelector('.pdd-toggle').addEventListener('click', function () {
    document.querySelector('.bike_details-wrapper').classList.toggle('active');
    document.querySelector('.pdd_image_wrapper').classList.toggle('active');
	document.querySelector('.pdd-toggle').classList.toggle('active');
});

/* ------- popup call back section js by rambeer -----------------*/
function scrollToTarget(targetId, offset = 130) {
    $('html, body').animate({
        scrollTop: $(targetId).offset().top - offset
    }, 600);
}

$('#edit-bike-info').on('click', function () {
    scrollToTarget('#add-new-bike');
});

$('#intrested').on('click', function () {
    scrollToTarget('#nudget-result');
});
$('.submit-plan-btn').on('click', function () {
    scrollToTarget('body');
});

$('#dealer-select-popup').on('click', function () {
    $('body').addClass('bike-details-page');
});

$('.bike-edit').on('click', function () {
    $('.previous_dealer_details-head').addClass('back-bike-details-page');
	$(".previous_dealer_details-head").removeClass("active");
	
	$("body").removeClass("bike-details-page");
});
$('.back-btn').on('click', function () {
	$(".previous_dealer_details-head").removeClass("active");
	$("body").removeClass("bike-details-page");
	$(".tvs-dealer-item").removeClass("expanded");
});
$(".collapse-btn").on("click", function (e) {
    $(".tvs-dealer-item.active").toggleClass("expanded");
});
$('.tooltip-custom').on("click", function () {
    $(this).toggleClass("open");
});

}); 





// Preven logot when user without enter the pincode  and hit the enter key
document.getElementById("pincode").addEventListener("keydown", function(e) {
  if (e.key === "Enter") {
    e.preventDefault();  // Stops page reload
    document.getElementById("pincode_button").click(); // Optional: trigger button
  }
});

// Mobile View JS
$(document).ready(function () {
  if ($(window).width() <= 768) {
    $('.back-btn, .bike-edit').on('click', function () {
      $('.tvs-dealer-section1 .dealer_contact_info').hide();
      $('.tvs-dealer-section1 .service-info-section').hide();
      $('.tvs-dealer-section1 .last-service-dealer').hide();
	  $(".pdd_image_wrapper").removeClass("active");
	$(".bike_details-wrapper").removeClass("active");
    });
  }
});
//Reload Page Clicking on Try Again Button
$('#try_agian_fatch_appointment').on('click', function (e) {
    location.reload();
});



